// controller.js
// helpers.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $defa8edbc79437a8$var$__assign = function() {
    $defa8edbc79437a8$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $defa8edbc79437a8$var$__assign.apply(this, arguments);
};
var $defa8edbc79437a8$export$1efaef7de3802058 = /** @class */ function() {
    function NotyfNotification(options) {
        this.options = options;
        this.listeners = {};
    }
    NotyfNotification.prototype.on = function(eventType, cb) {
        var callbacks = this.listeners[eventType] || [];
        this.listeners[eventType] = callbacks.concat([
            cb
        ]);
    };
    NotyfNotification.prototype.triggerEvent = function(eventType, event) {
        var _this = this;
        var callbacks = this.listeners[eventType] || [];
        callbacks.forEach(function(cb) {
            return cb({
                target: _this,
                event: event
            });
        });
    };
    return NotyfNotification;
}();
var $defa8edbc79437a8$export$2324fc501d2ffc65;
(function(NotyfArrayEvent) {
    NotyfArrayEvent[NotyfArrayEvent["Add"] = 0] = "Add";
    NotyfArrayEvent[NotyfArrayEvent["Remove"] = 1] = "Remove";
})($defa8edbc79437a8$export$2324fc501d2ffc65 || ($defa8edbc79437a8$export$2324fc501d2ffc65 = {}));
var $defa8edbc79437a8$export$7763ebb8bf460cea = /** @class */ function() {
    function NotyfArray() {
        this.notifications = [];
    }
    NotyfArray.prototype.push = function(elem) {
        this.notifications.push(elem);
        this.updateFn(elem, $defa8edbc79437a8$export$2324fc501d2ffc65.Add, this.notifications);
    };
    NotyfArray.prototype.splice = function(index, num) {
        var elem = this.notifications.splice(index, num)[0];
        this.updateFn(elem, $defa8edbc79437a8$export$2324fc501d2ffc65.Remove, this.notifications);
        return elem;
    };
    NotyfArray.prototype.indexOf = function(elem) {
        return this.notifications.indexOf(elem);
    };
    NotyfArray.prototype.onUpdate = function(fn) {
        this.updateFn = fn;
    };
    return NotyfArray;
}();
var $defa8edbc79437a8$export$776308576d349339;
(function(NotyfEvent) {
    NotyfEvent["Dismiss"] = "dismiss";
    NotyfEvent["Click"] = "click";
})($defa8edbc79437a8$export$776308576d349339 || ($defa8edbc79437a8$export$776308576d349339 = {}));
var $defa8edbc79437a8$export$93ca5d3f8675ae4c = {
    types: [
        {
            type: 'success',
            className: 'notyf__toast--success',
            backgroundColor: '#3dc763',
            icon: {
                className: 'notyf__icon--success',
                tagName: 'i'
            }
        },
        {
            type: 'error',
            className: 'notyf__toast--error',
            backgroundColor: '#ed3d3d',
            icon: {
                className: 'notyf__icon--error',
                tagName: 'i'
            }
        }
    ],
    duration: 2000,
    ripple: true,
    position: {
        x: 'right',
        y: 'bottom'
    },
    dismissible: false
};
var $defa8edbc79437a8$export$75d30b0f81ca0e5f = /** @class */ function() {
    function NotyfView() {
        this.notifications = [];
        this.events = {};
        this.X_POSITION_FLEX_MAP = {
            left: 'flex-start',
            center: 'center',
            right: 'flex-end'
        };
        this.Y_POSITION_FLEX_MAP = {
            top: 'flex-start',
            center: 'center',
            bottom: 'flex-end'
        };
        // Creates the main notifications container
        var docFrag = document.createDocumentFragment();
        var notyfContainer = this._createHTMLElement({
            tagName: 'div',
            className: 'notyf'
        });
        docFrag.appendChild(notyfContainer);
        document.body.appendChild(docFrag);
        this.container = notyfContainer;
        // Identifies the main animation end event
        this.animationEndEventName = this._getAnimationEndEventName();
        this._createA11yContainer();
    }
    NotyfView.prototype.on = function(event, cb) {
        var _a;
        this.events = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, this.events), (_a = {}, _a[event] = cb, _a));
    };
    NotyfView.prototype.update = function(notification, type) {
        if (type === $defa8edbc79437a8$export$2324fc501d2ffc65.Add) this.addNotification(notification);
        else if (type === $defa8edbc79437a8$export$2324fc501d2ffc65.Remove) this.removeNotification(notification);
    };
    NotyfView.prototype.removeNotification = function(notification) {
        var _this = this;
        var renderedNotification = this._popRenderedNotification(notification);
        var node;
        if (!renderedNotification) return;
        node = renderedNotification.node;
        node.classList.add('notyf__toast--disappear');
        var handleEvent;
        node.addEventListener(this.animationEndEventName, handleEvent = function(event) {
            if (event.target === node) {
                node.removeEventListener(_this.animationEndEventName, handleEvent);
                _this.container.removeChild(node);
            }
        });
    };
    NotyfView.prototype.addNotification = function(notification) {
        var node = this._renderNotification(notification);
        this.notifications.push({
            notification: notification,
            node: node
        });
        // For a11y purposes, we still want to announce that there's a notification in the screen
        // even if it comes with no message.
        this._announce(notification.options.message || 'Notification');
    };
    NotyfView.prototype._renderNotification = function(notification) {
        var _a;
        var card = this._buildNotificationCard(notification);
        var className = notification.options.className;
        if (className) (_a = card.classList).add.apply(_a, className.split(' '));
        this.container.appendChild(card);
        return card;
    };
    NotyfView.prototype._popRenderedNotification = function(notification) {
        var idx = -1;
        for(var i = 0; i < this.notifications.length && idx < 0; i++)if (this.notifications[i].notification === notification) idx = i;
        if (idx !== -1) return this.notifications.splice(idx, 1)[0];
        return;
    };
    NotyfView.prototype.getXPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.x) || 'right';
    };
    NotyfView.prototype.getYPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.y) || 'bottom';
    };
    NotyfView.prototype.adjustContainerAlignment = function(options) {
        var align = this.X_POSITION_FLEX_MAP[this.getXPosition(options)];
        var justify = this.Y_POSITION_FLEX_MAP[this.getYPosition(options)];
        var style = this.container.style;
        style.setProperty('justify-content', justify);
        style.setProperty('align-items', align);
    };
    NotyfView.prototype._buildNotificationCard = function(notification) {
        var _this = this;
        var options = notification.options;
        var iconOpts = options.icon;
        // Adjust container according to position (e.g. top-left, bottom-center, etc)
        this.adjustContainerAlignment(options);
        // Create elements
        var notificationElem = this._createHTMLElement({
            tagName: 'div',
            className: 'notyf__toast'
        });
        var ripple = this._createHTMLElement({
            tagName: 'div',
            className: 'notyf__ripple'
        });
        var wrapper = this._createHTMLElement({
            tagName: 'div',
            className: 'notyf__wrapper'
        });
        var message = this._createHTMLElement({
            tagName: 'div',
            className: 'notyf__message'
        });
        message.innerHTML = options.message || '';
        var mainColor = options.background || options.backgroundColor;
        // Build the icon and append it to the card
        if (iconOpts) {
            var iconContainer = this._createHTMLElement({
                tagName: 'div',
                className: 'notyf__icon'
            });
            if (typeof iconOpts === 'string' || iconOpts instanceof String) iconContainer.innerHTML = new String(iconOpts).valueOf();
            if (typeof iconOpts === 'object') {
                var _a = iconOpts.tagName, tagName = _a === void 0 ? 'i' : _a, className_1 = iconOpts.className, text = iconOpts.text, _b = iconOpts.color, color = _b === void 0 ? mainColor : _b;
                var iconElement = this._createHTMLElement({
                    tagName: tagName,
                    className: className_1,
                    text: text
                });
                if (color) iconElement.style.color = color;
                iconContainer.appendChild(iconElement);
            }
            wrapper.appendChild(iconContainer);
        }
        wrapper.appendChild(message);
        notificationElem.appendChild(wrapper);
        // Add ripple if applicable, else just paint the full toast
        if (mainColor) {
            if (options.ripple) {
                ripple.style.background = mainColor;
                notificationElem.appendChild(ripple);
            } else notificationElem.style.background = mainColor;
        }
        // Add dismiss button
        if (options.dismissible) {
            var dismissWrapper = this._createHTMLElement({
                tagName: 'div',
                className: 'notyf__dismiss'
            });
            var dismissButton = this._createHTMLElement({
                tagName: 'button',
                className: 'notyf__dismiss-btn'
            });
            dismissWrapper.appendChild(dismissButton);
            wrapper.appendChild(dismissWrapper);
            notificationElem.classList.add("notyf__toast--dismissible");
            dismissButton.addEventListener('click', function(event) {
                var _a, _b;
                (_b = (_a = _this.events)[$defa8edbc79437a8$export$776308576d349339.Dismiss]) === null || _b === void 0 || _b.call(_a, {
                    target: notification,
                    event: event
                });
                event.stopPropagation();
            });
        }
        notificationElem.addEventListener('click', function(event) {
            var _a, _b;
            return (_b = (_a = _this.events)[$defa8edbc79437a8$export$776308576d349339.Click]) === null || _b === void 0 ? void 0 : _b.call(_a, {
                target: notification,
                event: event
            });
        });
        // Adjust margins depending on whether its an upper or lower notification
        var className = this.getYPosition(options) === 'top' ? 'upper' : 'lower';
        notificationElem.classList.add("notyf__toast--" + className);
        return notificationElem;
    };
    NotyfView.prototype._createHTMLElement = function(_a) {
        var tagName = _a.tagName, className = _a.className, text = _a.text;
        var elem = document.createElement(tagName);
        if (className) elem.className = className;
        elem.textContent = text || null;
        return elem;
    };
    /**
     * Creates an invisible container which will announce the notyfs to
     * screen readers
     */ NotyfView.prototype._createA11yContainer = function() {
        var a11yContainer = this._createHTMLElement({
            tagName: 'div',
            className: 'notyf-announcer'
        });
        a11yContainer.setAttribute('aria-atomic', 'true');
        a11yContainer.setAttribute('aria-live', 'polite');
        // Set the a11y container to be visible hidden. Can't use display: none as
        // screen readers won't read it.
        a11yContainer.style.border = '0';
        a11yContainer.style.clip = 'rect(0 0 0 0)';
        a11yContainer.style.height = '1px';
        a11yContainer.style.margin = '-1px';
        a11yContainer.style.overflow = 'hidden';
        a11yContainer.style.padding = '0';
        a11yContainer.style.position = 'absolute';
        a11yContainer.style.width = '1px';
        a11yContainer.style.outline = '0';
        document.body.appendChild(a11yContainer);
        this.a11yContainer = a11yContainer;
    };
    /**
     * Announces a message to screenreaders.
     */ NotyfView.prototype._announce = function(message) {
        var _this = this;
        this.a11yContainer.textContent = '';
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        // https://github.com/angular/material2/blob/master/src/cdk/a11y/live-announcer/live-announcer.ts
        setTimeout(function() {
            _this.a11yContainer.textContent = message;
        }, 100);
    };
    /**
     * Determine which animationend event is supported
     */ NotyfView.prototype._getAnimationEndEventName = function() {
        var el = document.createElement('_fake');
        var transitions = {
            MozTransition: 'animationend',
            OTransition: 'oAnimationEnd',
            WebkitTransition: 'webkitAnimationEnd',
            transition: 'animationend'
        };
        var t;
        for(t in transitions){
            if (el.style[t] !== undefined) return transitions[t];
        }
        // No supported animation end event. Using "animationend" as a fallback
        return 'animationend';
    };
    return NotyfView;
}();
/**
 * Main controller class. Defines the main Notyf API.
 */ var $defa8edbc79437a8$export$146ebdf5fc143718 = /** @class */ function() {
    function Notyf(opts) {
        var _this = this;
        this.dismiss = this._removeNotification;
        this.notifications = new $defa8edbc79437a8$export$7763ebb8bf460cea();
        this.view = new $defa8edbc79437a8$export$75d30b0f81ca0e5f();
        var types = this.registerTypes(opts);
        this.options = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, $defa8edbc79437a8$export$93ca5d3f8675ae4c), opts);
        this.options.types = types;
        this.notifications.onUpdate(function(elem, type) {
            return _this.view.update(elem, type);
        });
        this.view.on($defa8edbc79437a8$export$776308576d349339.Dismiss, function(_a) {
            var target = _a.target, event = _a.event;
            _this._removeNotification(target);
            // tslint:disable-next-line: no-string-literal
            target['triggerEvent']($defa8edbc79437a8$export$776308576d349339.Dismiss, event);
        });
        // tslint:disable-next-line: no-string-literal
        this.view.on($defa8edbc79437a8$export$776308576d349339.Click, function(_a) {
            var target = _a.target, event = _a.event;
            return target['triggerEvent']($defa8edbc79437a8$export$776308576d349339.Click, event);
        });
    }
    Notyf.prototype.error = function(payload) {
        var options = this.normalizeOptions('error', payload);
        return this.open(options);
    };
    Notyf.prototype.success = function(payload) {
        var options = this.normalizeOptions('success', payload);
        return this.open(options);
    };
    Notyf.prototype.open = function(options) {
        var defaultOpts = this.options.types.find(function(_a) {
            var type = _a.type;
            return type === options.type;
        }) || {};
        var config = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, defaultOpts), options);
        this.assignProps([
            'ripple',
            'position',
            'dismissible'
        ], config);
        var notification = new $defa8edbc79437a8$export$1efaef7de3802058(config);
        this._pushNotification(notification);
        return notification;
    };
    Notyf.prototype.dismissAll = function() {
        while(this.notifications.splice(0, 1));
    };
    /**
     * Assigns properties to a config object based on two rules:
     * 1. If the config object already sets that prop, leave it as so
     * 2. Otherwise, use the default prop from the global options
     *
     * It's intended to build the final config object to open a notification. e.g. if
     * 'dismissible' is not set, then use the value from the global config.
     *
     * @param props - properties to be assigned to the config object
     * @param config - object whose properties need to be set
     */ Notyf.prototype.assignProps = function(props, config) {
        var _this = this;
        props.forEach(function(prop) {
            // intentional double equality to check for both null and undefined
            config[prop] = config[prop] == null ? _this.options[prop] : config[prop];
        });
    };
    Notyf.prototype._pushNotification = function(notification) {
        var _this = this;
        this.notifications.push(notification);
        var duration = notification.options.duration !== undefined ? notification.options.duration : this.options.duration;
        if (duration) setTimeout(function() {
            return _this._removeNotification(notification);
        }, duration);
    };
    Notyf.prototype._removeNotification = function(notification) {
        var index = this.notifications.indexOf(notification);
        if (index !== -1) this.notifications.splice(index, 1);
    };
    Notyf.prototype.normalizeOptions = function(type, payload) {
        var options = {
            type: type
        };
        if (typeof payload === 'string') options.message = payload;
        else if (typeof payload === 'object') options = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, options), payload);
        return options;
    };
    Notyf.prototype.registerTypes = function(opts) {
        var incomingTypes = (opts && opts.types || []).slice();
        var finalDefaultTypes = $defa8edbc79437a8$export$93ca5d3f8675ae4c.types.map(function(defaultType) {
            // find if there's a default type within the user input's types, if so, it means the user
            // wants to change some of the default settings
            var userTypeIdx = -1;
            incomingTypes.forEach(function(t, idx) {
                if (t.type === defaultType.type) userTypeIdx = idx;
            });
            var userType = userTypeIdx !== -1 ? incomingTypes.splice(userTypeIdx, 1)[0] : {};
            return $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, defaultType), userType);
        });
        return finalDefaultTypes.concat(incomingTypes);
    };
    return Notyf;
}();



// model.js

const $0f1d4402dffacf5b$export$a0e153c73743701a = {
    appointments: JSON.parse(localStorage.getItem('appointments')) || [],
    addresses: [],
    pendingAppointmentObject: localStorage.getItem('pendingAppointment') || null,
    currentAdminAccount: null,
    // Initialize state with local storage data
    initializeState () {
        this._finishAnyPendingRequests();
        this._initializeAppointments();
    },
    _finishAnyPendingRequests () {
        const currentRequest = (0, $bd02c871d9c5ba8e$export$93420f673d97440d)();
        if (currentRequest) this.pendingAppointmentObject = currentRequest;
    },
    async _initializeAddresses () {
        const db = await openDatabase();
        const fetchAddresses = new Promise((resolve, reject)=>{
            const transaction = db.transaction('addresses', 'readonly');
            const store = transaction.objectStore('addresses');
            const request = store.getAll();
            request.onsuccess = ()=>resolve(request.result || []);
            request.onerror = ()=>reject(request.error);
        });
        const addresses = await fetchAddresses;
        if (!addresses || addresses.length === 0) {
            console.log('IndexedDB is empty. Need to fetch data.');
            return false; // Database is not initialized
        }
        // console.log('Addresses fetched from IndexedDB:', addresses);
        this.addresses = addresses;
        return true; // Database is initialized
    },
    _initializeAppointments () {
        const storedAppointments = JSON.parse(localStorage.getItem('appointments')) || [];
        this.appointments = storedAppointments;
    },
    // Add appointment and update localStorage
    addAppointment (newAppointment) {
        // add 'status: confirmed'
        const aptWithStatusFlag = {
            ...newAppointment,
            status: 'confirmed'
        };
        this.appointments.push(aptWithStatusFlag);
        (0, $bd02c871d9c5ba8e$export$ace569e1140d7ad3)(aptWithStatusFlag);
        console.log('Added appointment:', aptWithStatusFlag);
    },
    // Delete appointment and update localStorage
    cancelAppointment (appointmentId) {
        this.appointments = this.appointments.filter((a)=>a.id !== appointmentId);
        (0, $bd02c871d9c5ba8e$export$890112004ddfc4a1)(this.appointments);
        console.log('Deleted appointment with ID:', appointmentId);
    },
    // Modify appointment and update localStorage
    modifyAppointment (appointmentId, updatedObject) {
        const appointmentIndex = this.appointments.findIndex((a)=>a.id === appointmentId);
        if (appointmentIndex !== -1) {
            this.appointments[appointmentIndex] = {
                ...this.appointments[appointmentIndex],
                ...updatedObject
            };
            (0, $bd02c871d9c5ba8e$export$890112004ddfc4a1)(this.appointments);
            console.log('Modified appointment:', updatedObject);
        }
    },
    //!  Admin Login Logic
    setAdminAccount (accountData) {
        this.currentAdminAccount = accountData;
        localStorage.setItem('currentAdminAccount', JSON.stringify(accountData)); // Persist the admin account
    },
    // Admin Logout Logic
    clearAdminAccount () {
        this.currentAdminAccount = null;
        localStorage.removeItem('currentAdminAccount'); // Remove from localStorage
    },
    // Handle Pending Appointment Reset
    clearPendingAppointment () {
        this.pendingAppointmentObject = null;
        localStorage.removeItem('pendingAppointment'); // Clear from localStorage
    }
};


function $bd02c871d9c5ba8e$export$890112004ddfc4a1(appointmentsArray = null) {
    if (appointmentsArray) localStorage.setItem('appointments', JSON.stringify(appointmentsArray));
    else {
        const appointments = generateMockAppointments();
        localStorage.setItem('appointments', JSON.stringify(appointments));
    }
}
function $bd02c871d9c5ba8e$export$ace569e1140d7ad3(newAppointment) {
    // Step 1: Retrieve the current appointments from localStorage (if any)
    let appointments = JSON.parse(localStorage.getItem('appointments')) || [];
    // Normalize input: trim spaces, convert to lowercase for comparison
    const normalizeText = (text)=>text ? text.trim().toLowerCase() : '';
    // Step 2: Make sure it isn't a duplicate (criteria: fullName and streetAddress are the same)
    const isDuplicate = appointments?.some((apt)=>normalizeText(apt.fullName) === normalizeText(newAppointment.fullName) && normalizeText(apt.streetAddress) === normalizeText(newAppointment.streetAddress) && apt.zipCode === newAppointment.zipCode);
    // * improvement to implement: show the previous appointment screen (or a link to cancel it)!
    if (isDuplicate) throw new Error("You've already made an appointment with us! Please cancel it before we can book a new one for you!");
    console.log('adding to local storage (success)');
    // Step 3: Add the new appointment to the array
    appointments.push(newAppointment);
    // Step 3: Store the updated array back into localStorage
    localStorage.setItem('appointments', JSON.stringify(appointments));
}
function $bd02c871d9c5ba8e$export$93420f673d97440d() {
    try {
        // Check for any pending appointment submission
        const pendingAppointment = localStorage.getItem('pendingAppointment');
        if (!pendingAppointment) return false;
        const formData = JSON.parse(pendingAppointment);
        // Show spinner and retry processing
        $bd02c871d9c5ba8e$export$6c49cf36d8dc363f.open({
            type: 'warning',
            message: 'Resuming your previous appointment request...'
        });
        return formData;
    } catch (err) {
        console.error('Error resuming pending appointment:', err);
    } finally{
        localStorage.removeItem('pendingAppointment'); // Clean up if there's an issue
    }
}
function $bd02c871d9c5ba8e$export$5437abf948861fe0(headerElement) {
    if (!(0, $0f1d4402dffacf5b$export$a0e153c73743701a).currentAdminAccount) throw new Error("account couldn't be found in AppState");
    else {
        // Update button text
        headerElement.textContent = `${(0, $0f1d4402dffacf5b$export$a0e153c73743701a).currentAdminAccount.username[0].toUpperCase() + (0, $0f1d4402dffacf5b$export$a0e153c73743701a).currentAdminAccount.username.slice(1)} logged in`;
        // Update styles
        headerElement.style.color = 'var(--color-secondary)';
        headerElement.style.cursor = 'not-allowed';
        headerElement.style.pointerEvents = 'none';
        // Disable its parent container if needed
        const toggleLoginContainer = headerElement.closest('.toggle-login-btn');
        if (toggleLoginContainer) toggleLoginContainer.style.pointerEvents = 'none';
    }
}
function $bd02c871d9c5ba8e$export$4190cb8f14494955(headerElement) {
    // Check if the currentAdminAccount is present in AppState
    if (!(0, $0f1d4402dffacf5b$export$a0e153c73743701a).currentAdminAccount) throw new Error("Account couldn't be found in AppState");
    else {
        // Reset header element text and styles
        headerElement.textContent = 'Admin Login'; // Or whatever default text should be
        headerElement.style.color = ''; // Reset color to default
        headerElement.style.cursor = ''; // Reset cursor style
        headerElement.style.pointerEvents = ''; // Reset pointer events
        // Re-enable the parent container of the toggle login button
        const toggleLoginContainer = headerElement.closest('.toggle-login-btn');
        if (toggleLoginContainer) toggleLoginContainer.style.pointerEvents = '';
    }
}
function $bd02c871d9c5ba8e$export$838972faedb21271(sectionsToHide) {
    // first add hiddenSection class to all
    sectionsToHide.forEach((section)=>section.classList.add('hideSection'));
    const adminSectionElement = document.querySelector('.admin-section');
    // then remove it from the adminSection
    adminSectionElement.classList.remove('hideSection');
}
function $bd02c871d9c5ba8e$export$f633bf8f6c244212(sectionsToShow) {
    // First, remove the "hideSection" class from all sections that were hidden
    sectionsToShow.forEach((section)=>section.classList.remove('hideSection'));
    const adminSectionElement = document.querySelector('.admin-section');
    // Add the "hideSection" class back to the admin section to hide it again
    if (adminSectionElement) adminSectionElement.classList.add('hideSection');
}
function $bd02c871d9c5ba8e$export$3ae94a2503e890a1(date, options = null) {
    if (options) return new Intl.DateTimeFormat('en', options).format(new Date(date));
    return new Intl.DateTimeFormat('en', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        weekday: 'long'
    }).format(new Date(date));
}
const $bd02c871d9c5ba8e$export$6c49cf36d8dc363f = new (0, $defa8edbc79437a8$export$146ebdf5fc143718)({
    duration: 5000,
    position: {
        x: 'center',
        y: 'top'
    },
    types: [
        {
            type: 'warning',
            background: 'orange',
            icon: {
                className: 'material-icons',
                tagName: 'i',
                text: 'warning'
            }
        },
        {
            type: 'success',
            background: 'green',
            duration: 3000,
            dismissible: true
        },
        {
            type: 'error',
            background: 'indianred',
            duration: 7000,
            dismissible: true
        },
        {
            type: 'confirmation',
            background: '#5d5a88',
            duration: 10000,
            dismissible: false,
            message: "Appointment Successfully booked! Confirmation email is on it's way! To modify/cancel please call us at +1 (800)-888-000.  ",
            icon: {
                className: 'material-icons',
                tagName: 'i'
            },
            className: 'notyf-confirmation'
        }
    ]
});
function $bd02c871d9c5ba8e$export$61fc7d43ac8f84b0(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>func.apply(this, args), wait);
    };
}
function $bd02c871d9c5ba8e$export$6a3c3e474807cf13(record, tokens) {
    let score = 0;
    // Match on street name
    if (record?.streetName && tokens?.some((token)=>record.streetName.toLowerCase().includes(token))) score += 3;
    // Match on street direction (only if it exists)
    if (record.streetDirection && tokens?.some((token)=>record.streetDirection.toLowerCase().includes(token))) score += 2;
    // Match on street type (if present)
    if (record.streetType && tokens?.some((token)=>record.streetType.toLowerCase().includes(token))) score += 1;
    // Match on street number (if present)
    if (record.streetNumber && tokens?.some((token)=>record.streetNumber.toLowerCase().includes(token))) score += 1;
    return score;
}
function $bd02c871d9c5ba8e$export$4998f14ece55e591(address) {
    return address.toLowerCase().trim().split(/\s+/); // Split by spaces
}


// databaseUtility.js
const $ba30e20475feac5a$export$78bb294dd8b45952 = 'CityDataDB';
const $ba30e20475feac5a$export$42d4f6269b4a05d2 = 'addresses';
const $ba30e20475feac5a$export$413899dff10bd19d = {
    username: 'admin',
    password: 'password123'
};



async function $85015d9f7ab58335$export$a317418cf2fea366() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open((0, $ba30e20475feac5a$export$78bb294dd8b45952), 1);
        request.onupgradeneeded = function() {
            const db = request.result;
            // addresses store with indexes
            if (!db.objectStoreNames.contains('addresses')) {
                const addressStore = db.createObjectStore('addresses', {
                    keyPath: 'id'
                });
                addressStore.createIndex('zipCode', 'zipCode', {
                    unique: false
                });
                addressStore.createIndex('searchableAddress', 'searchableAddress', {
                    unique: false
                });
                addressStore.createIndex('searchableTokens', 'searchableAddressTokens', {
                    unique: false,
                    multiEntry: true
                });
            }
        };
        request.onsuccess = ()=>resolve(request.result);
        request.onerror = ()=>reject(request.error);
    });
}
let $85015d9f7ab58335$var$fetchAndStoreDataPromise = null;
async function $85015d9f7ab58335$export$a690621f3480c1f1() {
    if ($85015d9f7ab58335$var$fetchAndStoreDataPromise) return $85015d9f7ab58335$var$fetchAndStoreDataPromise; // Return the existing promise if already running
    $85015d9f7ab58335$var$fetchAndStoreDataPromise = (async ()=>{
        try {
            console.log('Starting fetchAndStoreData...');
            $0f1d4402dffacf5b$export$a0e153c73743701a.isFetchingData = true;
            const response = await fetch('https://data.lacity.org/api/views/4ca8-mxuh/rows.json?accessType=DOWNLOAD');
            const data = await response.json();
            const addresses = data.data.filter((item)=>item[18]).map((item, index)=>{
                const addressString = `${item[11]} ${item[13]} ${item[14]} ${item[15]}`.trim();
                return {
                    id: index + 1,
                    streetNumber: item[11],
                    streetDirection: item[13],
                    streetName: item[14],
                    streetType: item[15],
                    zipCode: item[18],
                    lat: item[19],
                    lng: item[20],
                    searchableAddress: addressString.toLowerCase(),
                    searchableAddressTokens: $85015d9f7ab58335$export$4998f14ece55e591(addressString)
                };
            });
            const db = await $85015d9f7ab58335$export$a317418cf2fea366();
            const batchSize = 1000;
            for(let i = 0; i < addresses.length; i += batchSize){
                const batch = addresses.slice(i, i + batchSize);
                await $85015d9f7ab58335$var$storeDataBatch(db, batch);
            }
            console.log('All data stored successfully.');
            $0f1d4402dffacf5b$export$a0e153c73743701a.isDataLoaded = true;
        } catch (err) {
            console.error('Error in fetchAndStoreData:', err);
        } finally{
            $0f1d4402dffacf5b$export$a0e153c73743701a.isFetchingData = false;
            $85015d9f7ab58335$var$fetchAndStoreDataPromise = null; // Reset promise after completion
        }
    })();
    return $85015d9f7ab58335$var$fetchAndStoreDataPromise;
}
// Store data in IndexedDB in batches
async function $85015d9f7ab58335$var$storeDataBatch(db, batch) {
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction((0, $ba30e20475feac5a$export$42d4f6269b4a05d2), 'readwrite');
        const store = transaction.objectStore((0, $ba30e20475feac5a$export$42d4f6269b4a05d2));
        batch.forEach((item)=>store.put(item));
        transaction.oncomplete = resolve;
        transaction.onerror = ()=>reject(transaction.error);
    });
}
function $85015d9f7ab58335$export$61fc7d43ac8f84b0(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>func.apply(this, args), wait);
    };
}
function $85015d9f7ab58335$export$6a3c3e474807cf13(record, tokens) {
    let score = 0;
    // Match on street name
    if (record?.streetName && tokens?.some((token)=>record.streetName.toLowerCase().includes(token))) score += 3;
    // Match on street direction (only if it exists)
    if (record.streetDirection && tokens?.some((token)=>record.streetDirection.toLowerCase().includes(token))) score += 2;
    // Match on street type (if present)
    if (record.streetType && tokens?.some((token)=>record.streetType.toLowerCase().includes(token))) score += 1;
    // Match on street number (if present)
    if (record.streetNumber && tokens?.some((token)=>record.streetNumber.toLowerCase().includes(token))) score += 1;
    return score;
}
function $85015d9f7ab58335$export$4998f14ece55e591(address) {
    return address.toLowerCase().trim().split(/\s+/); // Split by spaces
}
async function $85015d9f7ab58335$export$7c06382ce0ff786b(zipCode, query) {
    const db = await $85015d9f7ab58335$export$a317418cf2fea366();
    const formattedZipCode = zipCode.trim(); // Ensure no extra spaces in zipCode
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction((0, $ba30e20475feac5a$export$42d4f6269b4a05d2), 'readonly');
        const store = transaction.objectStore('addresses');
        const zipCodeIndex = store.index('zipCode');
        // Fetch all records matching the zip code
        const zipRequest = zipCodeIndex.getAll(formattedZipCode);
        zipRequest.onsuccess = function() {
            const zipFilteredResults = zipRequest.result;
            if (!query?.trim()) {
                resolve(zipFilteredResults.slice(0, 10)); // Return top 10 if no query
                return;
            }
            const tokens = query.toLowerCase().trim().split(/\s+/); // Tokenize query
            // Refined results based on tokens
            const refinedResults = zipFilteredResults.filter((record)=>tokens.every((token)=>record.searchableAddress.includes(token) || record.searchableAddressTokens && record.searchableAddressTokens.includes(token)));
            // Calculate relevance score for refined results
            refinedResults.forEach((result)=>{
                result.matchScore = $85015d9f7ab58335$export$6a3c3e474807cf13(result, tokens);
            });
            refinedResults.sort((a, b)=>b.matchScore - a.matchScore); // Sort by match score
            resolve(refinedResults.slice(0, 10)); // Limit to top 10 results
        };
        zipRequest.onerror = (error)=>reject(error);
    });
}
async function $85015d9f7ab58335$export$5bafc354b7e37022(zipCode, streetAddress) {
    try {
        // Ensure data is present in the database
        const isDatabasePopulated = await $85015d9f7ab58335$export$21848577fbad2669();
        if (!isDatabasePopulated) {
            console.log('Database is empty, fetching data...');
            await $85015d9f7ab58335$export$a690621f3480c1f1();
        }
        console.log('database populated');
        const db = await $85015d9f7ab58335$export$a317418cf2fea366();
        // Format input
        const formattedZipCode = zipCode.trim();
        const tokens = streetAddress.toLowerCase().trim().split(/\s+/);
        return new Promise((resolve, reject)=>{
            const transaction = db.transaction((0, $ba30e20475feac5a$export$42d4f6269b4a05d2), 'readonly');
            const store = transaction.objectStore((0, $ba30e20475feac5a$export$42d4f6269b4a05d2));
            // Using zipCodeIndex to fetch addresses that match the zip code first
            const zipCodeIndex = store.index('zipCode');
            const zipRequest = zipCodeIndex.getAll(formattedZipCode);
            zipRequest.onsuccess = function() {
                const zipFilteredResults = zipRequest.result;
                // If no results found for zipCode, return false immediately
                if (!zipFilteredResults || zipFilteredResults.length === 0) {
                    resolve(false);
                    return;
                }
                // Tokenize the query to match against 'searchableAddressTokens'
                const matchedResults = zipFilteredResults.filter((record)=>{
                    // Check if all tokens exist in the searchable tokens of the address
                    return tokens.every((token)=>record.searchableAddressTokens.includes(token));
                });
                // If any record matched all tokens, return true
                resolve(matchedResults.length > 0);
            };
            zipRequest.onerror = function() {
                reject(zipRequest.error);
            };
        });
    } catch (error) {
        console.error('Error in optimizedValidateAddress:', error);
        return false;
    }
}
async function $85015d9f7ab58335$export$21848577fbad2669() {
    try {
        const db = await $85015d9f7ab58335$export$a317418cf2fea366();
        return new Promise((resolve, reject)=>{
            const transaction = db.transaction((0, $ba30e20475feac5a$export$42d4f6269b4a05d2), 'readonly');
            const store = transaction.objectStore((0, $ba30e20475feac5a$export$42d4f6269b4a05d2));
            // Count the number of entries in the store
            const countRequest = store.count();
            countRequest.onsuccess = ()=>resolve(countRequest.result > 50);
            countRequest.onerror = ()=>reject(countRequest.error);
        });
    } catch (error) {
        console.error('Error checking database population:', error);
        return false;
    }
}





class $3cb67d0201f829e7$export$2e2bcd8739ae039 {
    _modal;
    _modalOverlay;
    _modalToggleButton;
    _submitButton;
    _closeButton;
    constructor(modalElement, overlayElement, toggleButtonEl, submitButtonEl){
        this._modal = document.querySelector(modalElement);
        this._modalOverlay = document.querySelector(overlayElement);
        this._modalToggleButton = document.querySelectorAll(toggleButtonEl);
        this._submitButton = document.querySelector(submitButtonEl);
        // ! Bind methods
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.detectOutsideClickOrESCKeypress = this.detectOutsideClickOrESCKeypress.bind(this);
        this.preventCloseOnInsideClick = this.preventCloseOnInsideClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this); // Bind close method
        this._createCloseButton();
        this._initEventListeners();
    }
    // Add event listeners for toggle, close on outside click, and ESC keypress
    _initEventListeners() {
        this.addHandlerToggleModal();
        this.addHandlerSubmitForm();
        this.addHandlerCloseOnOutsideClickOrESCKeypress();
        this.addHandlerPreventCloseOnModal();
        this.addHandlerCloseButton(); // Add close button handler
    }
    // Create close button and append it to modal
    _createCloseButton() {
        this._closeButton = document.createElement('button');
        this._closeButton.classList.add('modal-close-btn');
        this._closeButton.classList.add('button');
        this._closeButton.classList.add('nav-cta-btn');
        this._closeButton.innerHTML = '&times;'; // 'X' symbol
        this._modal.appendChild(this._closeButton);
    }
    // Handle closing the modal
    handleCloseModal() {
        this.toggleVisibility(this._modal, this._modalOverlay);
    }
    handleToggleModal() {
        const isVisible = !this._modal.classList.contains('hidden');
        // Call toggleVisibility only once with the correct state
        if (isVisible) this.toggleVisibility(this._modal, this._modalOverlay); // Close modal
        else {
            this.toggleVisibility(this._modal, this._modalOverlay); // Open modal
            this._focusFirstInput();
        // Focus the first input field inside the modal
        }
    }
    _focusFirstInput() {
        const firstInput = this._modal.querySelector('input, textarea, select');
        if (firstInput) requestAnimationFrame(()=>{
            firstInput.focus();
        });
    }
    // Toggle visibility and add class to body
    toggleVisibility(...elements) {
        elements.forEach((el)=>{
            if (el.classList.contains('hidden')) {
                el.classList.remove('hidden');
                el.classList.add('visible');
                document.body.classList.add('modal-open');
                this._focusFirstInput();
            } else {
                el.classList.remove('visible');
                el.classList.add('hidden');
                document.body.classList.remove('modal-open');
            }
        });
    }
    // Handle closing modal on outside click or ESC key press
    detectOutsideClickOrESCKeypress(e) {
        const isOutsideClick = e.type === 'click' && e.target === this._modalOverlay;
        const isESCKeyPress = e.type === 'keydown' && e.key === 'Escape';
        if (isESCKeyPress && !this._modal.classList.contains('hidden')) this.toggleVisibility(this._modal, this._modalOverlay);
        else if (isOutsideClick) this.toggleVisibility(this._modal, this._modalOverlay);
    }
    // Prevent clicks inside the modal from toggling or closing it
    preventCloseOnInsideClick(e) {
        e.stopPropagation();
    }
    // Cleanup event listeners when modal is closed
    cleanupHandlers() {
        if (this._modalOverlay) this._modalOverlay.removeEventListener('click', this.detectOutsideClickOrESCKeypress);
        document.removeEventListener('keydown', this.detectOutsideClickOrESCKeypress);
        if (this._modal) this._modal.removeEventListener('click', this.preventCloseOnInsideClick);
    }
    // Add handler for opening/closing modal
    addHandlerToggleModal() {
        if (this._modalToggleButton) this._modalToggleButton.forEach((button)=>button.addEventListener('click', this.handleToggleModal));
    }
    // ! FORM SUBMIT HANDLER
    async handleFormSubmit(e, onSuccess) {
        e.preventDefault();
        try {
            // EDITING
            const isEditingSession = this._modal.classList.contains('edit-session') || this._submitButton.classList.contains('edit-session');
            if (isEditingSession) {
                console.log('Edit session detected. Handling edit logic.');
                await this._saveEditedAppointment();
                return;
            }
            // REGULAR SUBMIT
            this._submitButton.disabled = true;
            const isValid = await this._validator.isValid;
            if (isValid) {
                const formData = this.getFormData();
                if (onSuccess) onSuccess(formData);
            }
        } catch (error) {
            console.error('Form submission error:', error);
            notyf.error('An error occurred during form submission.');
        } finally{
            this._submitButton.disabled = false;
        }
    }
    // Add handler for form Submit
    addHandlerSubmitForm(handlerFunction = null, isEditingSession = false) {
        if (!this._modal || !this._submitButton) return;
        if (handlerFunction === null) {
            this._modal.addEventListener('submit', this.handleFormSubmit);
            return;
        }
        if (handlerFunction) this._modal.addEventListener('submit', async (e)=>{
            await this.handleFormSubmit(e, handlerFunction);
        });
    }
    addHandlerCloseButton() {
        if (this._closeButton) this._closeButton.addEventListener('click', this.handleCloseModal);
    }
    // Add handler for closing modal on outside click or ESC key press
    addHandlerCloseOnOutsideClickOrESCKeypress() {
        if (this._modalOverlay) this._modalOverlay.addEventListener('click', this.detectOutsideClickOrESCKeypress);
        document.addEventListener('keydown', this.detectOutsideClickOrESCKeypress);
    }
    // Prevent closing modal when clicking inside it
    addHandlerPreventCloseOnModal() {
        if (this._modal) this._modal.addEventListener('click', this.preventCloseOnInsideClick);
    }
}


var $d27bb703914f23c0$var$__defProp = Object.defineProperty;
var $d27bb703914f23c0$var$__defNormalProp = (obj, key, value)=>key in obj ? $d27bb703914f23c0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d27bb703914f23c0$var$__publicField = (obj, key, value)=>{
    $d27bb703914f23c0$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $d27bb703914f23c0$var$EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $d27bb703914f23c0$var$INTEGER_REGEXP = /^-?[0-9]\d*$/;
const $d27bb703914f23c0$var$PASSWORD_REGEXP = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
const $d27bb703914f23c0$var$STRONG_PASSWORD_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
const $d27bb703914f23c0$var$isEmpty = (value)=>{
    let newVal = value;
    if (typeof value === "string") newVal = value.trim();
    return !newVal;
};
const $d27bb703914f23c0$var$isEmail = (value)=>{
    return $d27bb703914f23c0$var$EMAIL_REGEXP.test(value);
};
const $d27bb703914f23c0$var$isLengthMoreThanMax = (value, len)=>{
    return value.length > len;
};
const $d27bb703914f23c0$var$isLengthLessThanMin = (value, len)=>{
    return value.length < len;
};
const $d27bb703914f23c0$var$isNumber = (value)=>{
    if (typeof value !== "string") return false;
    return !isNaN(+value) && !isNaN(parseFloat(value));
};
const $d27bb703914f23c0$var$isInteger = (value)=>{
    return $d27bb703914f23c0$var$INTEGER_REGEXP.test(value);
};
const $d27bb703914f23c0$var$isPassword = (value)=>{
    return $d27bb703914f23c0$var$PASSWORD_REGEXP.test(value);
};
const $d27bb703914f23c0$var$isStrongPassword = (value)=>{
    return $d27bb703914f23c0$var$STRONG_PASSWORD_REGEXP.test(value);
};
const $d27bb703914f23c0$var$isNumberMoreThanMax = (value, len)=>{
    return value > len;
};
const $d27bb703914f23c0$var$isNumberLessThanMin = (value, len)=>{
    return value < len;
};
const $d27bb703914f23c0$var$isInvalidOrEmptyString = (value)=>{
    return typeof value !== "string" || value === "";
};
var $d27bb703914f23c0$export$374633da432e5a39 = /* @__PURE__ */ ((Rules2)=>{
    Rules2["Required"] = "required";
    Rules2["Email"] = "email";
    Rules2["MinLength"] = "minLength";
    Rules2["MaxLength"] = "maxLength";
    Rules2["Password"] = "password";
    Rules2["Number"] = "number";
    Rules2["Integer"] = "integer";
    Rules2["MaxNumber"] = "maxNumber";
    Rules2["MinNumber"] = "minNumber";
    Rules2["StrongPassword"] = "strongPassword";
    Rules2["CustomRegexp"] = "customRegexp";
    Rules2["MinFilesCount"] = "minFilesCount";
    Rules2["MaxFilesCount"] = "maxFilesCount";
    Rules2["Files"] = "files";
    return Rules2;
})($d27bb703914f23c0$export$374633da432e5a39 || {});
var $d27bb703914f23c0$export$a5d622529213a571 = /* @__PURE__ */ ((GroupRules2)=>{
    GroupRules2["Required"] = "required";
    return GroupRules2;
})($d27bb703914f23c0$export$a5d622529213a571 || {});
var $d27bb703914f23c0$export$491c8086b854a9ef = /* @__PURE__ */ ((CustomStyleTagIds2)=>{
    CustomStyleTagIds2["Label"] = "label";
    CustomStyleTagIds2["LabelArrow"] = "labelArrow";
    return CustomStyleTagIds2;
})($d27bb703914f23c0$export$491c8086b854a9ef || {});
const $d27bb703914f23c0$var$defaultDictionary = [
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.Required,
        dict: {
            en: "The field is required"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.Email,
        dict: {
            en: "Email has invalid format"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.MaxLength,
        dict: {
            en: "The field must contain a maximum of :value characters"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.MinLength,
        dict: {
            en: "The field must contain a minimum of :value characters"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.Password,
        dict: {
            en: "Password must contain minimum eight characters, at least one letter and one number"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.StrongPassword,
        dict: {
            en: "Password should contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.Number,
        dict: {
            en: "Value should be a number"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.MaxNumber,
        dict: {
            en: "Number should be less or equal than :value"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.MinNumber,
        dict: {
            en: "Number should be more or equal than :value"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.MinFilesCount,
        dict: {
            en: "Files count should be more or equal than :value"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.MaxFilesCount,
        dict: {
            en: "Files count should be less or equal than :value"
        }
    },
    {
        key: $d27bb703914f23c0$export$374633da432e5a39.Files,
        dict: {
            en: "Uploaded files have one or several invalid properties (extension/size/type etc)."
        }
    }
];
const $d27bb703914f23c0$var$DEFAULT_ERROR_FIELD_MESSAGE = "Value is incorrect";
const $d27bb703914f23c0$var$isPromise = (val)=>typeof val === "object" && val !== null && "then" in val && typeof val.then === "function";
const $d27bb703914f23c0$var$getNodeParents = (el)=>{
    let elem = el;
    const els = [];
    while(elem){
        els.unshift(elem);
        elem = elem.parentNode;
    }
    return els;
};
const $d27bb703914f23c0$var$getClosestParent = (groups, parents)=>{
    const reversedParents = [
        ...parents
    ].reverse();
    for(let i = 0, len = reversedParents.length; i < len; ++i){
        const parent = reversedParents[i];
        for(const key in groups){
            const group = groups[key];
            if (group.groupElem === parent) return [
                key,
                group
            ];
        }
    }
    return null;
};
const $d27bb703914f23c0$var$getClassList = (classList)=>{
    if (Array.isArray(classList)) return classList.filter((cls)=>cls.length > 0);
    if (typeof classList === "string" && classList.trim()) return [
        ...classList.split(" ").filter((cls)=>cls.length > 0)
    ];
    return [];
};
const $d27bb703914f23c0$var$isElement = (element)=>{
    return element instanceof Element || element instanceof HTMLDocument;
};
const $d27bb703914f23c0$var$errorLabelCss = `.just-validate-error-label[data-tooltip=true]{position:fixed;padding:4px 8px;background:#423f3f;color:#fff;white-space:nowrap;z-index:10;border-radius:4px;transform:translateY(-5px)}.just-validate-error-label[data-tooltip=true]:before{content:'';width:0;height:0;border-left:solid 5px transparent;border-right:solid 5px transparent;border-bottom:solid 5px #423f3f;position:absolute;z-index:3;display:block;bottom:-5px;transform:rotate(180deg);left:calc(50% - 5px)}.just-validate-error-label[data-tooltip=true][data-direction=left]{transform:translateX(-5px)}.just-validate-error-label[data-tooltip=true][data-direction=left]:before{right:-7px;bottom:auto;left:auto;top:calc(50% - 2px);transform:rotate(90deg)}.just-validate-error-label[data-tooltip=true][data-direction=right]{transform:translateX(5px)}.just-validate-error-label[data-tooltip=true][data-direction=right]:before{right:auto;bottom:auto;left:-7px;top:calc(50% - 2px);transform:rotate(-90deg)}.just-validate-error-label[data-tooltip=true][data-direction=bottom]{transform:translateY(5px)}.just-validate-error-label[data-tooltip=true][data-direction=bottom]:before{right:auto;bottom:auto;left:calc(50% - 5px);top:-5px;transform:rotate(0)}`;
const $d27bb703914f23c0$var$TOOLTIP_ARROW_HEIGHT = 5;
const $d27bb703914f23c0$var$defaultGlobalConfig = {
    errorFieldStyle: {
        color: "#b81111",
        border: "1px solid #B81111"
    },
    errorFieldCssClass: "just-validate-error-field",
    successFieldCssClass: "just-validate-success-field",
    errorLabelStyle: {
        color: "#b81111"
    },
    errorLabelCssClass: "just-validate-error-label",
    successLabelCssClass: "just-validate-success-label",
    focusInvalidField: true,
    lockForm: true,
    testingMode: false,
    validateBeforeSubmitting: false,
    submitFormAutomatically: false
};
class $d27bb703914f23c0$export$2e2bcd8739ae039 {
    constructor(form, globalConfig, dictLocale){
        $d27bb703914f23c0$var$__publicField(this, "form", null);
        $d27bb703914f23c0$var$__publicField(this, "fields", {});
        $d27bb703914f23c0$var$__publicField(this, "groupFields", {});
        $d27bb703914f23c0$var$__publicField(this, "errors", {});
        $d27bb703914f23c0$var$__publicField(this, "isValid", false);
        $d27bb703914f23c0$var$__publicField(this, "isSubmitted", false);
        $d27bb703914f23c0$var$__publicField(this, "globalConfig", $d27bb703914f23c0$var$defaultGlobalConfig);
        $d27bb703914f23c0$var$__publicField(this, "errorLabels", {});
        $d27bb703914f23c0$var$__publicField(this, "successLabels", {});
        $d27bb703914f23c0$var$__publicField(this, "eventListeners", []);
        $d27bb703914f23c0$var$__publicField(this, "dictLocale", $d27bb703914f23c0$var$defaultDictionary);
        $d27bb703914f23c0$var$__publicField(this, "currentLocale", "en");
        $d27bb703914f23c0$var$__publicField(this, "customStyleTags", {});
        $d27bb703914f23c0$var$__publicField(this, "onSuccessCallback");
        $d27bb703914f23c0$var$__publicField(this, "onFailCallback");
        $d27bb703914f23c0$var$__publicField(this, "onValidateCallback");
        $d27bb703914f23c0$var$__publicField(this, "tooltips", []);
        $d27bb703914f23c0$var$__publicField(this, "lastScrollPosition");
        $d27bb703914f23c0$var$__publicField(this, "isScrollTick");
        $d27bb703914f23c0$var$__publicField(this, "fieldIds", /* @__PURE__ */ new Map());
        $d27bb703914f23c0$var$__publicField(this, "getKeyByFieldSelector", (field)=>{
            return this.fieldIds.get(field);
        });
        $d27bb703914f23c0$var$__publicField(this, "getFieldSelectorByKey", (key)=>{
            for (const [fieldSelector, k] of this.fieldIds){
                if (key === k) return fieldSelector;
            }
            return void 0;
        });
        $d27bb703914f23c0$var$__publicField(this, "getCompatibleFields", ()=>{
            const fields = {};
            Object.keys(this.fields).forEach((key)=>{
                let newKey = key;
                const fieldSelector = this.getFieldSelectorByKey(key);
                if (typeof fieldSelector === "string") newKey = fieldSelector;
                fields[newKey] = {
                    ...this.fields[key]
                };
            });
            return fields;
        });
        $d27bb703914f23c0$var$__publicField(this, "setKeyByFieldSelector", (field)=>{
            if (this.fieldIds.has(field)) return this.fieldIds.get(field);
            const key = String(this.fieldIds.size + 1);
            this.fieldIds.set(field, key);
            return key;
        });
        $d27bb703914f23c0$var$__publicField(this, "refreshAllTooltips", ()=>{
            this.tooltips.forEach((item)=>{
                item.refresh();
            });
        });
        $d27bb703914f23c0$var$__publicField(this, "handleDocumentScroll", ()=>{
            this.lastScrollPosition = window.scrollY;
            if (!this.isScrollTick) {
                window.requestAnimationFrame(()=>{
                    this.refreshAllTooltips();
                    this.isScrollTick = false;
                });
                this.isScrollTick = true;
            }
        });
        $d27bb703914f23c0$var$__publicField(this, "formSubmitHandler", (ev)=>{
            ev.preventDefault();
            this.isSubmitted = true;
            this.validateHandler(ev);
        });
        $d27bb703914f23c0$var$__publicField(this, "handleFieldChange", (target)=>{
            let foundKey;
            for(const key in this.fields){
                const field = this.fields[key];
                if (field.elem === target) {
                    foundKey = key;
                    break;
                }
            }
            if (!foundKey) return;
            this.fields[foundKey].touched = true;
            this.validateField(foundKey, true);
        });
        $d27bb703914f23c0$var$__publicField(this, "handleGroupChange", (target)=>{
            let foundKey;
            for(const key in this.groupFields){
                const group = this.groupFields[key];
                if (group.elems.find((elem)=>elem === target)) {
                    foundKey = key;
                    break;
                }
            }
            if (!foundKey) return;
            this.groupFields[foundKey].touched = true;
            this.validateGroup(foundKey, true);
        });
        $d27bb703914f23c0$var$__publicField(this, "handlerChange", (ev)=>{
            if (!ev.target) return;
            this.handleFieldChange(ev.target);
            this.handleGroupChange(ev.target);
            this.renderErrors();
        });
        this.initialize(form, globalConfig, dictLocale);
    }
    initialize(form, globalConfig, dictLocale) {
        this.form = null;
        this.errors = {};
        this.isValid = false;
        this.isSubmitted = false;
        this.globalConfig = $d27bb703914f23c0$var$defaultGlobalConfig;
        this.errorLabels = {};
        this.successLabels = {};
        this.eventListeners = [];
        this.customStyleTags = {};
        this.tooltips = [];
        this.currentLocale = "en";
        if (typeof form === "string") {
            const elem = document.querySelector(form);
            if (!elem) throw Error(`Form with ${form} selector not found! Please check the form selector`);
            this.setForm(elem);
        } else if (form instanceof HTMLFormElement) this.setForm(form);
        else throw Error(`Form selector is not valid. Please specify a string selector or a DOM element.`);
        this.globalConfig = {
            ...$d27bb703914f23c0$var$defaultGlobalConfig,
            ...globalConfig
        };
        if (dictLocale) this.dictLocale = [
            ...dictLocale,
            ...$d27bb703914f23c0$var$defaultDictionary
        ];
        if (this.isTooltip()) {
            const styleTag = document.createElement("style");
            styleTag.textContent = $d27bb703914f23c0$var$errorLabelCss;
            this.customStyleTags[$d27bb703914f23c0$export$491c8086b854a9ef.Label] = document.head.appendChild(styleTag);
            this.addListener("scroll", document, this.handleDocumentScroll);
        }
    }
    getLocalisedString(rule, ruleValue, customMsg) {
        var _a;
        const search = customMsg != null ? customMsg : rule;
        let localisedStr = (_a = this.dictLocale.find((item)=>item.key === search)) == null ? void 0 : _a.dict[this.currentLocale];
        if (!localisedStr) {
            if (customMsg) localisedStr = customMsg;
        }
        if (localisedStr && ruleValue !== void 0) switch(rule){
            case $d27bb703914f23c0$export$374633da432e5a39.MaxLength:
            case $d27bb703914f23c0$export$374633da432e5a39.MinLength:
            case $d27bb703914f23c0$export$374633da432e5a39.MaxNumber:
            case $d27bb703914f23c0$export$374633da432e5a39.MinNumber:
            case $d27bb703914f23c0$export$374633da432e5a39.MinFilesCount:
            case $d27bb703914f23c0$export$374633da432e5a39.MaxFilesCount:
                localisedStr = localisedStr.replace(":value", String(ruleValue));
        }
        return localisedStr || customMsg || $d27bb703914f23c0$var$DEFAULT_ERROR_FIELD_MESSAGE;
    }
    getFieldErrorMessage(fieldRule, elem) {
        const msg = typeof fieldRule.errorMessage === "function" ? fieldRule.errorMessage(this.getElemValue(elem), this.fields) : fieldRule.errorMessage;
        return this.getLocalisedString(fieldRule.rule, fieldRule.value, msg);
    }
    getFieldSuccessMessage(successMessage, elem) {
        const msg = typeof successMessage === "function" ? successMessage(this.getElemValue(elem), this.fields) : successMessage;
        return this.getLocalisedString(void 0, void 0, msg);
    }
    getGroupErrorMessage(groupRule) {
        return this.getLocalisedString(groupRule.rule, void 0, groupRule.errorMessage);
    }
    getGroupSuccessMessage(groupRule) {
        if (!groupRule.successMessage) return void 0;
        return this.getLocalisedString(void 0, void 0, groupRule.successMessage);
    }
    setFieldInvalid(key, fieldRule) {
        this.fields[key].isValid = false;
        this.fields[key].errorMessage = this.getFieldErrorMessage(fieldRule, this.fields[key].elem);
    }
    setFieldValid(key, successMessage) {
        this.fields[key].isValid = true;
        if (successMessage !== void 0) this.fields[key].successMessage = this.getFieldSuccessMessage(successMessage, this.fields[key].elem);
    }
    setGroupInvalid(key, groupRule) {
        this.groupFields[key].isValid = false;
        this.groupFields[key].errorMessage = this.getGroupErrorMessage(groupRule);
    }
    setGroupValid(key, groupRule) {
        this.groupFields[key].isValid = true;
        this.groupFields[key].successMessage = this.getGroupSuccessMessage(groupRule);
    }
    getElemValue(elem) {
        switch(elem.type){
            case "checkbox":
                return elem.checked;
            case "file":
                return elem.files;
            default:
                return elem.value;
        }
    }
    validateGroupRule(key, elems, groupRule) {
        switch(groupRule.rule){
            case $d27bb703914f23c0$export$a5d622529213a571.Required:
                if (elems.every((elem)=>!elem.checked)) this.setGroupInvalid(key, groupRule);
                else this.setGroupValid(key, groupRule);
        }
    }
    validateFieldRule(key, elem, fieldRule, afterInputChanged = false) {
        const ruleValue = fieldRule.value;
        const elemValue = this.getElemValue(elem);
        if (fieldRule.plugin) {
            const result = fieldRule.plugin(elemValue, this.getCompatibleFields());
            if (!result) this.setFieldInvalid(key, fieldRule);
            return;
        }
        switch(fieldRule.rule){
            case $d27bb703914f23c0$export$374633da432e5a39.Required:
                if ($d27bb703914f23c0$var$isEmpty(elemValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.Email:
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if (!$d27bb703914f23c0$var$isEmail(elemValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.MaxLength:
                if (ruleValue === void 0) {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. The field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if (typeof ruleValue !== "number") {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] should be a number. The field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if ($d27bb703914f23c0$var$isLengthMoreThanMax(elemValue, ruleValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.MinLength:
                if (ruleValue === void 0) {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. The field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if (typeof ruleValue !== "number") {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] should be a number. The field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if ($d27bb703914f23c0$var$isLengthLessThanMin(elemValue, ruleValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.Password:
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if (!$d27bb703914f23c0$var$isPassword(elemValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.StrongPassword:
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if (!$d27bb703914f23c0$var$isStrongPassword(elemValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.Number:
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if (!$d27bb703914f23c0$var$isNumber(elemValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.Integer:
                if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                if (!$d27bb703914f23c0$var$isInteger(elemValue)) this.setFieldInvalid(key, fieldRule);
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.MaxNumber:
                {
                    if (ruleValue === void 0) {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. The field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        break;
                    }
                    if (typeof ruleValue !== "number") {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field should be a number. The field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        break;
                    }
                    if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                    const num = +elemValue;
                    if (Number.isNaN(num) || $d27bb703914f23c0$var$isNumberMoreThanMax(num, ruleValue)) this.setFieldInvalid(key, fieldRule);
                    break;
                }
            case $d27bb703914f23c0$export$374633da432e5a39.MinNumber:
                {
                    if (ruleValue === void 0) {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. The field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        break;
                    }
                    if (typeof ruleValue !== "number") {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field should be a number. The field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        break;
                    }
                    if ($d27bb703914f23c0$var$isInvalidOrEmptyString(elemValue)) break;
                    const num = +elemValue;
                    if (Number.isNaN(num) || $d27bb703914f23c0$var$isNumberLessThanMin(num, ruleValue)) this.setFieldInvalid(key, fieldRule);
                    break;
                }
            case $d27bb703914f23c0$export$374633da432e5a39.CustomRegexp:
                {
                    if (ruleValue === void 0) {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. This field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        return;
                    }
                    let regexp;
                    try {
                        regexp = new RegExp(ruleValue);
                    } catch (e) {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] should be a valid regexp. This field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        break;
                    }
                    const str = String(elemValue);
                    if (str !== "" && !regexp.test(str)) this.setFieldInvalid(key, fieldRule);
                    break;
                }
            case $d27bb703914f23c0$export$374633da432e5a39.MinFilesCount:
                if (ruleValue === void 0) {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. This field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if (typeof ruleValue !== "number") {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] field should be a number. The field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if (Number.isFinite(elemValue == null ? void 0 : elemValue.length) && elemValue.length < ruleValue) {
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.MaxFilesCount:
                if (ruleValue === void 0) {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. This field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if (typeof ruleValue !== "number") {
                    console.error(`Value for ${fieldRule.rule} rule for [${key}] field should be a number. The field will be always invalid.`);
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                if (Number.isFinite(elemValue == null ? void 0 : elemValue.length) && elemValue.length > ruleValue) {
                    this.setFieldInvalid(key, fieldRule);
                    break;
                }
                break;
            case $d27bb703914f23c0$export$374633da432e5a39.Files:
                {
                    if (ruleValue === void 0) {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field is not defined. This field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        return;
                    }
                    if (typeof ruleValue !== "object") {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field should be an object. This field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        return;
                    }
                    const filesConfig = ruleValue.files;
                    if (typeof filesConfig !== "object") {
                        console.error(`Value for ${fieldRule.rule} rule for [${key}] field should be an object with files array. This field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        return;
                    }
                    const isFilePropsInvalid = (file, fileConfig)=>{
                        const minSizeInvalid = Number.isFinite(fileConfig.minSize) && file.size < fileConfig.minSize;
                        const maxSizeInvalid = Number.isFinite(fileConfig.maxSize) && file.size > fileConfig.maxSize;
                        const nameInvalid = Array.isArray(fileConfig.names) && !fileConfig.names.includes(file.name);
                        const extInvalid = Array.isArray(fileConfig.extensions) && !fileConfig.extensions.includes(file.name.split(".")[file.name.split(".").length - 1]);
                        const typeInvalid = Array.isArray(fileConfig.types) && !fileConfig.types.includes(file.type);
                        return minSizeInvalid || maxSizeInvalid || nameInvalid || extInvalid || typeInvalid;
                    };
                    if (typeof elemValue === "object" && elemValue !== null) for(let fileIdx = 0, len = elemValue.length; fileIdx < len; ++fileIdx){
                        const file = elemValue.item(fileIdx);
                        if (!file) {
                            this.setFieldInvalid(key, fieldRule);
                            break;
                        }
                        const filesInvalid = isFilePropsInvalid(file, filesConfig);
                        if (filesInvalid) {
                            this.setFieldInvalid(key, fieldRule);
                            break;
                        }
                    }
                    break;
                }
            default:
                {
                    if (typeof fieldRule.validator !== "function") {
                        console.error(`Validator for custom rule for [${key}] field should be a function. This field will be always invalid.`);
                        this.setFieldInvalid(key, fieldRule);
                        return;
                    }
                    const result = fieldRule.validator(elemValue, this.getCompatibleFields());
                    if (typeof result !== "boolean" && typeof result !== "function") console.error(`Validator return value for [${key}] field should be boolean or function. It will be cast to boolean.`);
                    if (typeof result === "function") {
                        if (afterInputChanged) this.fields[key].asyncCheckPending = true;
                        else {
                            this.fields[key].asyncCheckPending = false;
                            const promise = result();
                            if (!$d27bb703914f23c0$var$isPromise(promise)) {
                                console.error(`Validator function for custom rule for [${key}] field should return a Promise. This field will be always invalid.`);
                                this.setFieldInvalid(key, fieldRule);
                                return;
                            }
                            return promise.then((resp)=>{
                                if (!resp) this.setFieldInvalid(key, fieldRule);
                            }).catch(()=>{
                                this.setFieldInvalid(key, fieldRule);
                            });
                        }
                    }
                    if (!result) this.setFieldInvalid(key, fieldRule);
                }
        }
    }
    isFormValid() {
        let isValid = true;
        for(let i = 0, len = Object.values(this.fields).length; i < len; ++i){
            const item = Object.values(this.fields)[i];
            if (item.isValid === void 0) {
                isValid = void 0;
                break;
            }
            if (item.isValid === false) {
                isValid = false;
                break;
            }
        }
        for(let i = 0, len = Object.values(this.groupFields).length; i < len; ++i){
            const item = Object.values(this.groupFields)[i];
            if (item.isValid === void 0) {
                isValid = void 0;
                break;
            }
            if (item.isValid === false) {
                isValid = false;
                break;
            }
        }
        return isValid;
    }
    validateField(key, afterInputChanged = false) {
        var _a;
        const field = this.fields[key];
        field.isValid = true;
        const promises = [];
        [
            ...field.rules
        ].reverse().forEach((rule)=>{
            const res = this.validateFieldRule(key, field.elem, rule, afterInputChanged);
            if ($d27bb703914f23c0$var$isPromise(res)) promises.push(res);
        });
        if (field.isValid) this.setFieldValid(key, (_a = field.config) == null ? void 0 : _a.successMessage);
        return Promise.allSettled(promises).finally(()=>{
            var _a2;
            if (afterInputChanged) (_a2 = this.onValidateCallback) == null || _a2.call(this, {
                isValid: this.isFormValid(),
                isSubmitted: this.isSubmitted,
                fields: this.getCompatibleFields(),
                groups: {
                    ...this.groupFields
                }
            });
        });
    }
    revalidateField(fieldSelector) {
        if (typeof fieldSelector !== "string" && !$d27bb703914f23c0$var$isElement(fieldSelector)) throw Error(`Field selector is not valid. Please specify a string selector or a valid DOM element.`);
        const key = this.getKeyByFieldSelector(fieldSelector);
        if (!key || !this.fields[key]) {
            console.error(`Field not found. Check the field selector.`);
            return Promise.reject();
        }
        return new Promise((resolve)=>{
            this.validateField(key, true).finally(()=>{
                this.clearFieldStyle(key);
                this.clearFieldLabel(key);
                this.renderFieldError(key, true);
                resolve(!!this.fields[key].isValid);
            });
        });
    }
    revalidateGroup(groupSelector) {
        if (typeof groupSelector !== "string" && !$d27bb703914f23c0$var$isElement(groupSelector)) throw Error(`Group selector is not valid. Please specify a string selector or a valid DOM element.`);
        const key = this.getKeyByFieldSelector(groupSelector);
        if (!key || !this.groupFields[key]) {
            console.error(`Group not found. Check the group selector.`);
            return Promise.reject();
        }
        return new Promise((resolve)=>{
            this.validateGroup(key).finally(()=>{
                this.clearFieldLabel(key);
                this.renderGroupError(key, true);
                resolve(!!this.groupFields[key].isValid);
            });
        });
    }
    validateGroup(key, afterInputChanged = false) {
        const group = this.groupFields[key];
        const promises = [];
        [
            ...group.rules
        ].reverse().forEach((rule)=>{
            const res = this.validateGroupRule(key, group.elems, rule);
            if ($d27bb703914f23c0$var$isPromise(res)) promises.push(res);
        });
        return Promise.allSettled(promises).finally(()=>{
            var _a;
            if (afterInputChanged) (_a = this.onValidateCallback) == null || _a.call(this, {
                isValid: this.isFormValid(),
                isSubmitted: this.isSubmitted,
                fields: this.getCompatibleFields(),
                groups: {
                    ...this.groupFields
                }
            });
        });
    }
    focusInvalidField() {
        for(const key in this.fields){
            const field = this.fields[key];
            if (!field.isValid) {
                setTimeout(()=>field.elem.focus(), 0);
                break;
            }
        }
    }
    afterSubmitValidation(forceRevalidation = false) {
        this.renderErrors(forceRevalidation);
        if (this.globalConfig.focusInvalidField) this.focusInvalidField();
    }
    validate(forceRevalidation = false) {
        return new Promise((resolve)=>{
            const promises = [];
            Object.keys(this.fields).forEach((key)=>{
                const promise = this.validateField(key);
                if ($d27bb703914f23c0$var$isPromise(promise)) promises.push(promise);
            });
            Object.keys(this.groupFields).forEach((key)=>{
                const promise = this.validateGroup(key);
                if ($d27bb703914f23c0$var$isPromise(promise)) promises.push(promise);
            });
            Promise.allSettled(promises).then(()=>{
                var _a;
                this.afterSubmitValidation(forceRevalidation);
                (_a = this.onValidateCallback) == null || _a.call(this, {
                    isValid: this.isFormValid(),
                    isSubmitted: this.isSubmitted,
                    fields: this.getCompatibleFields(),
                    groups: {
                        ...this.groupFields
                    }
                });
                resolve(!!promises.length);
            });
        });
    }
    revalidate() {
        return new Promise((resolve)=>{
            this.validateHandler(void 0, true).finally(()=>{
                if (this.globalConfig.focusInvalidField) this.focusInvalidField();
                resolve(this.isValid);
            });
        });
    }
    validateHandler(ev, forceRevalidation = false) {
        if (this.globalConfig.lockForm) this.lockForm();
        return this.validate(forceRevalidation).finally(()=>{
            var _a, _b, _c;
            if (this.globalConfig.lockForm) this.unlockForm();
            if (this.isValid) {
                (_a = this.onSuccessCallback) == null || _a.call(this, ev);
                if (this.globalConfig.submitFormAutomatically) (_b = ev == null ? void 0 : ev.currentTarget) == null || _b.submit();
            } else (_c = this.onFailCallback) == null || _c.call(this, this.getCompatibleFields(), this.groupFields);
        });
    }
    setForm(form) {
        this.form = form;
        this.form.setAttribute("novalidate", "novalidate");
        this.removeListener("submit", this.form, this.formSubmitHandler);
        this.addListener("submit", this.form, this.formSubmitHandler);
    }
    addListener(type, elem, handler) {
        elem.addEventListener(type, handler);
        this.eventListeners.push({
            type: type,
            elem: elem,
            func: handler
        });
    }
    removeListener(type, elem, handler) {
        elem.removeEventListener(type, handler);
        this.eventListeners = this.eventListeners.filter((item)=>item.type !== type || item.elem !== elem);
    }
    addField(fieldSelector, rules, config) {
        if (typeof fieldSelector !== "string" && !$d27bb703914f23c0$var$isElement(fieldSelector)) throw Error(`Field selector is not valid. Please specify a string selector or a valid DOM element.`);
        let elem;
        if (typeof fieldSelector === "string") elem = this.form.querySelector(fieldSelector);
        else elem = fieldSelector;
        if (!elem) throw Error(`Field doesn't exist in the DOM! Please check the field selector.`);
        if (!Array.isArray(rules) || !rules.length) throw Error(`Rules argument should be an array and should contain at least 1 element.`);
        rules.forEach((item)=>{
            if (!("rule" in item || "validator" in item || "plugin" in item)) throw Error(`Rules argument must contain at least one rule or validator property.`);
            if (!item.validator && !item.plugin && (!item.rule || !Object.values($d27bb703914f23c0$export$374633da432e5a39).includes(item.rule))) throw Error(`Rule should be one of these types: ${Object.values($d27bb703914f23c0$export$374633da432e5a39).join(", ")}. Provided value: ${item.rule}`);
        });
        const key = this.setKeyByFieldSelector(fieldSelector);
        this.fields[key] = {
            elem: elem,
            rules: rules,
            isValid: void 0,
            touched: false,
            config: config
        };
        this.setListeners(elem);
        if (this.isSubmitted || this.globalConfig.validateBeforeSubmitting) this.validateField(key);
        return this;
    }
    removeField(fieldSelector) {
        if (typeof fieldSelector !== "string" && !$d27bb703914f23c0$var$isElement(fieldSelector)) throw Error(`Field selector is not valid. Please specify a string selector or a valid DOM element.`);
        const key = this.getKeyByFieldSelector(fieldSelector);
        if (!key || !this.fields[key]) {
            console.error(`Field not found. Check the field selector.`);
            return this;
        }
        const type = this.getListenerType(this.fields[key].elem.type);
        this.removeListener(type, this.fields[key].elem, this.handlerChange);
        this.clearErrors();
        delete this.fields[key];
        return this;
    }
    removeGroup(group) {
        if (typeof group !== "string") throw Error(`Group selector is not valid. Please specify a string selector.`);
        const key = this.getKeyByFieldSelector(group);
        if (!key || !this.groupFields[key]) {
            console.error(`Group not found. Check the group selector.`);
            return this;
        }
        this.groupFields[key].elems.forEach((elem)=>{
            const type = this.getListenerType(elem.type);
            this.removeListener(type, elem, this.handlerChange);
        });
        this.clearErrors();
        delete this.groupFields[key];
        return this;
    }
    addRequiredGroup(groupField, errorMessage, config, successMessage) {
        if (typeof groupField !== "string" && !$d27bb703914f23c0$var$isElement(groupField)) throw Error(`Group selector is not valid. Please specify a string selector or a valid DOM element.`);
        let elem;
        if (typeof groupField === "string") elem = this.form.querySelector(groupField);
        else elem = groupField;
        if (!elem) throw Error(`Group selector not found! Please check the group selector.`);
        const inputs = elem.querySelectorAll("input");
        const childrenInputs = Array.from(inputs).filter((input)=>{
            const parent = $d27bb703914f23c0$var$getClosestParent(this.groupFields, $d27bb703914f23c0$var$getNodeParents(input));
            if (!parent) return true;
            return parent[1].elems.find((elem2)=>elem2 !== input);
        });
        const key = this.setKeyByFieldSelector(groupField);
        this.groupFields[key] = {
            rules: [
                {
                    rule: $d27bb703914f23c0$export$a5d622529213a571.Required,
                    errorMessage: errorMessage,
                    successMessage: successMessage
                }
            ],
            groupElem: elem,
            elems: childrenInputs,
            touched: false,
            isValid: void 0,
            config: config
        };
        inputs.forEach((input)=>{
            this.setListeners(input);
        });
        return this;
    }
    getListenerType(type) {
        switch(type){
            case "checkbox":
            case "select-one":
            case "file":
            case "radio":
                return "change";
            default:
                return "input";
        }
    }
    setListeners(elem) {
        const type = this.getListenerType(elem.type);
        this.removeListener(type, elem, this.handlerChange);
        this.addListener(type, elem, this.handlerChange);
    }
    clearFieldLabel(key) {
        var _a, _b;
        (_a = this.errorLabels[key]) == null || _a.remove();
        (_b = this.successLabels[key]) == null || _b.remove();
    }
    clearFieldStyle(key) {
        var _a, _b, _c, _d;
        const field = this.fields[key];
        const errorStyle = ((_a = field.config) == null ? void 0 : _a.errorFieldStyle) || this.globalConfig.errorFieldStyle;
        Object.keys(errorStyle).forEach((key2)=>{
            field.elem.style[key2] = "";
        });
        const successStyle = ((_b = field.config) == null ? void 0 : _b.successFieldStyle) || this.globalConfig.successFieldStyle || {};
        Object.keys(successStyle).forEach((key2)=>{
            field.elem.style[key2] = "";
        });
        field.elem.classList.remove(...$d27bb703914f23c0$var$getClassList(((_c = field.config) == null ? void 0 : _c.errorFieldCssClass) || this.globalConfig.errorFieldCssClass), ...$d27bb703914f23c0$var$getClassList(((_d = field.config) == null ? void 0 : _d.successFieldCssClass) || this.globalConfig.successFieldCssClass));
    }
    clearErrors() {
        var _a, _b;
        Object.keys(this.errorLabels).forEach((key)=>this.errorLabels[key].remove());
        Object.keys(this.successLabels).forEach((key)=>this.successLabels[key].remove());
        for(const key in this.fields)this.clearFieldStyle(key);
        for(const key in this.groupFields){
            const group = this.groupFields[key];
            const errorStyle = ((_a = group.config) == null ? void 0 : _a.errorFieldStyle) || this.globalConfig.errorFieldStyle;
            Object.keys(errorStyle).forEach((key2)=>{
                group.elems.forEach((elem)=>{
                    var _a2;
                    elem.style[key2] = "";
                    elem.classList.remove(...$d27bb703914f23c0$var$getClassList(((_a2 = group.config) == null ? void 0 : _a2.errorFieldCssClass) || this.globalConfig.errorFieldCssClass));
                });
            });
            const successStyle = ((_b = group.config) == null ? void 0 : _b.successFieldStyle) || this.globalConfig.successFieldStyle || {};
            Object.keys(successStyle).forEach((key2)=>{
                group.elems.forEach((elem)=>{
                    var _a2;
                    elem.style[key2] = "";
                    elem.classList.remove(...$d27bb703914f23c0$var$getClassList(((_a2 = group.config) == null ? void 0 : _a2.successFieldCssClass) || this.globalConfig.successFieldCssClass));
                });
            });
        }
        this.tooltips = [];
    }
    isTooltip() {
        return !!this.globalConfig.tooltip;
    }
    lockForm() {
        const elems = this.form.querySelectorAll("input, textarea, button, select");
        for(let i = 0, len = elems.length; i < len; ++i){
            elems[i].setAttribute("data-just-validate-fallback-disabled", elems[i].disabled ? "true" : "false");
            elems[i].setAttribute("disabled", "disabled");
            elems[i].style.pointerEvents = "none";
            elems[i].style.webkitFilter = "grayscale(100%)";
            elems[i].style.filter = "grayscale(100%)";
        }
    }
    unlockForm() {
        const elems = this.form.querySelectorAll("input, textarea, button, select");
        for(let i = 0, len = elems.length; i < len; ++i){
            if (elems[i].getAttribute("data-just-validate-fallback-disabled") !== "true") elems[i].removeAttribute("disabled");
            elems[i].style.pointerEvents = "";
            elems[i].style.webkitFilter = "";
            elems[i].style.filter = "";
        }
    }
    renderTooltip(elem, errorLabel, position) {
        var _a;
        const { top: top, left: left, width: width, height: height } = elem.getBoundingClientRect();
        const errorLabelRect = errorLabel.getBoundingClientRect();
        const pos = position || ((_a = this.globalConfig.tooltip) == null ? void 0 : _a.position);
        switch(pos){
            case "left":
                errorLabel.style.top = `${top + height / 2 - errorLabelRect.height / 2}px`;
                errorLabel.style.left = `${left - errorLabelRect.width - $d27bb703914f23c0$var$TOOLTIP_ARROW_HEIGHT}px`;
                break;
            case "top":
                errorLabel.style.top = `${top - errorLabelRect.height - $d27bb703914f23c0$var$TOOLTIP_ARROW_HEIGHT}px`;
                errorLabel.style.left = `${left + width / 2 - errorLabelRect.width / 2}px`;
                break;
            case "right":
                errorLabel.style.top = `${top + height / 2 - errorLabelRect.height / 2}px`;
                errorLabel.style.left = `${left + width + $d27bb703914f23c0$var$TOOLTIP_ARROW_HEIGHT}px`;
                break;
            case "bottom":
                errorLabel.style.top = `${top + height + $d27bb703914f23c0$var$TOOLTIP_ARROW_HEIGHT}px`;
                errorLabel.style.left = `${left + width / 2 - errorLabelRect.width / 2}px`;
                break;
        }
        errorLabel.dataset.direction = pos;
        const refresh = ()=>{
            this.renderTooltip(elem, errorLabel, position);
        };
        return {
            refresh: refresh
        };
    }
    createErrorLabelElem(key, errorMessage, config) {
        const errorLabel = document.createElement("div");
        errorLabel.innerHTML = errorMessage;
        const customErrorLabelStyle = this.isTooltip() ? config == null ? void 0 : config.errorLabelStyle : (config == null ? void 0 : config.errorLabelStyle) || this.globalConfig.errorLabelStyle;
        Object.assign(errorLabel.style, customErrorLabelStyle);
        errorLabel.classList.add(...$d27bb703914f23c0$var$getClassList((config == null ? void 0 : config.errorLabelCssClass) || this.globalConfig.errorLabelCssClass), "just-validate-error-label");
        if (this.isTooltip()) errorLabel.dataset.tooltip = "true";
        if (this.globalConfig.testingMode) errorLabel.dataset.testId = `error-label-${key}`;
        this.errorLabels[key] = errorLabel;
        return errorLabel;
    }
    createSuccessLabelElem(key, successMessage, config) {
        if (successMessage === void 0) return null;
        const successLabel = document.createElement("div");
        successLabel.innerHTML = successMessage;
        const customSuccessLabelStyle = (config == null ? void 0 : config.successLabelStyle) || this.globalConfig.successLabelStyle;
        Object.assign(successLabel.style, customSuccessLabelStyle);
        successLabel.classList.add(...$d27bb703914f23c0$var$getClassList((config == null ? void 0 : config.successLabelCssClass) || this.globalConfig.successLabelCssClass), "just-validate-success-label");
        if (this.globalConfig.testingMode) successLabel.dataset.testId = `success-label-${key}`;
        this.successLabels[key] = successLabel;
        return successLabel;
    }
    renderErrorsContainer(label, errorsContainer) {
        const container = errorsContainer || this.globalConfig.errorsContainer;
        if (typeof container === "string") {
            const elem = this.form.querySelector(container);
            if (elem) {
                elem.appendChild(label);
                return true;
            } else console.error(`Error container with ${container} selector not found. Errors will be rendered as usual`);
        }
        if (container instanceof Element) {
            container.appendChild(label);
            return true;
        }
        if (container !== void 0) console.error(`Error container not found. It should be a string or existing Element. Errors will be rendered as usual`);
        return false;
    }
    renderGroupLabel(elem, label, errorsContainer, isSuccess) {
        if (!isSuccess) {
            const renderedInErrorsContainer = this.renderErrorsContainer(label, errorsContainer);
            if (renderedInErrorsContainer) return;
        }
        elem.appendChild(label);
    }
    renderFieldLabel(elem, label, errorsContainer, isSuccess) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!isSuccess) {
            const renderedInErrorsContainer = this.renderErrorsContainer(label, errorsContainer);
            if (renderedInErrorsContainer) return;
        }
        if (elem.type === "checkbox" || elem.type === "radio") {
            const labelElem = document.querySelector(`label[for="${elem.getAttribute("id")}"]`);
            if (((_b = (_a = elem.parentElement) == null ? void 0 : _a.tagName) == null ? void 0 : _b.toLowerCase()) === "label") (_d = (_c = elem.parentElement) == null ? void 0 : _c.parentElement) == null || _d.appendChild(label);
            else if (labelElem) (_e = labelElem.parentElement) == null || _e.appendChild(label);
            else (_f = elem.parentElement) == null || _f.appendChild(label);
        } else (_g = elem.parentElement) == null || _g.appendChild(label);
    }
    showLabels(fields, isError) {
        Object.keys(fields).forEach((fieldName, i)=>{
            const error = fields[fieldName];
            const key = this.getKeyByFieldSelector(fieldName);
            if (!key || !this.fields[key]) {
                console.error(`Field not found. Check the field selector.`);
                return;
            }
            const field = this.fields[key];
            field.isValid = !isError;
            this.clearFieldStyle(key);
            this.clearFieldLabel(key);
            this.renderFieldError(key, false, error);
            if (i === 0 && this.globalConfig.focusInvalidField) setTimeout(()=>field.elem.focus(), 0);
        });
    }
    showErrors(fields) {
        if (typeof fields !== "object") throw Error("[showErrors]: Errors should be an object with key: value format");
        this.showLabels(fields, true);
    }
    showSuccessLabels(fields) {
        if (typeof fields !== "object") throw Error("[showSuccessLabels]: Labels should be an object with key: value format");
        this.showLabels(fields, false);
    }
    renderFieldError(key, forced = false, message) {
        var _a, _b, _c, _d, _e, _f;
        const field = this.fields[key];
        if (field.isValid === false) this.isValid = false;
        if (field.isValid === void 0 || !forced && !this.isSubmitted && !field.touched && message === void 0) return;
        if (field.isValid) {
            if (!field.asyncCheckPending) {
                const successLabel = this.createSuccessLabelElem(key, message !== void 0 ? message : field.successMessage, field.config);
                if (successLabel) this.renderFieldLabel(field.elem, successLabel, (_a = field.config) == null ? void 0 : _a.errorsContainer, true);
                field.elem.classList.add(...$d27bb703914f23c0$var$getClassList(((_b = field.config) == null ? void 0 : _b.successFieldCssClass) || this.globalConfig.successFieldCssClass));
            }
            return;
        }
        field.elem.classList.add(...$d27bb703914f23c0$var$getClassList(((_c = field.config) == null ? void 0 : _c.errorFieldCssClass) || this.globalConfig.errorFieldCssClass));
        const errorLabel = this.createErrorLabelElem(key, message !== void 0 ? message : field.errorMessage, field.config);
        this.renderFieldLabel(field.elem, errorLabel, (_d = field.config) == null ? void 0 : _d.errorsContainer);
        if (this.isTooltip()) this.tooltips.push(this.renderTooltip(field.elem, errorLabel, (_f = (_e = field.config) == null ? void 0 : _e.tooltip) == null ? void 0 : _f.position));
    }
    renderGroupError(key, force = true) {
        var _a, _b, _c, _d;
        const group = this.groupFields[key];
        if (group.isValid === false) this.isValid = false;
        if (group.isValid === void 0 || !force && !this.isSubmitted && !group.touched) return;
        if (group.isValid) {
            group.elems.forEach((elem)=>{
                var _a2, _b2;
                Object.assign(elem.style, ((_a2 = group.config) == null ? void 0 : _a2.successFieldStyle) || this.globalConfig.successFieldStyle);
                elem.classList.add(...$d27bb703914f23c0$var$getClassList(((_b2 = group.config) == null ? void 0 : _b2.successFieldCssClass) || this.globalConfig.successFieldCssClass));
            });
            const successLabel = this.createSuccessLabelElem(key, group.successMessage, group.config);
            if (successLabel) this.renderGroupLabel(group.groupElem, successLabel, (_a = group.config) == null ? void 0 : _a.errorsContainer, true);
            return;
        }
        this.isValid = false;
        group.elems.forEach((elem)=>{
            var _a2, _b2;
            Object.assign(elem.style, ((_a2 = group.config) == null ? void 0 : _a2.errorFieldStyle) || this.globalConfig.errorFieldStyle);
            elem.classList.add(...$d27bb703914f23c0$var$getClassList(((_b2 = group.config) == null ? void 0 : _b2.errorFieldCssClass) || this.globalConfig.errorFieldCssClass));
        });
        const errorLabel = this.createErrorLabelElem(key, group.errorMessage, group.config);
        this.renderGroupLabel(group.groupElem, errorLabel, (_b = group.config) == null ? void 0 : _b.errorsContainer);
        if (this.isTooltip()) this.tooltips.push(this.renderTooltip(group.groupElem, errorLabel, (_d = (_c = group.config) == null ? void 0 : _c.tooltip) == null ? void 0 : _d.position));
    }
    renderErrors(forceRevalidation = false) {
        if (!this.isSubmitted && !forceRevalidation && !this.globalConfig.validateBeforeSubmitting) return;
        this.clearErrors();
        this.isValid = true;
        for(const key in this.groupFields)this.renderGroupError(key);
        for(const key in this.fields)this.renderFieldError(key);
    }
    destroy() {
        this.eventListeners.forEach((event)=>{
            this.removeListener(event.type, event.elem, event.func);
        });
        Object.keys(this.customStyleTags).forEach((key)=>{
            this.customStyleTags[key].remove();
        });
        this.clearErrors();
        if (this.globalConfig.lockForm) this.unlockForm();
    }
    refresh() {
        this.destroy();
        if (!this.form) console.error("Cannot initialize the library! Form is not defined");
        else {
            this.initialize(this.form, this.globalConfig);
            Object.keys(this.fields).forEach((key)=>{
                const fieldSelector = this.getFieldSelectorByKey(key);
                if (fieldSelector) this.addField(fieldSelector, [
                    ...this.fields[key].rules
                ], this.fields[key].config);
            });
        }
    }
    setCurrentLocale(locale) {
        if (typeof locale !== "string" && locale !== void 0) {
            console.error("Current locale should be a string");
            return;
        }
        this.currentLocale = locale;
        if (this.isSubmitted) this.validate();
    }
    onSuccess(callback) {
        this.onSuccessCallback = callback;
        return this;
    }
    onFail(callback) {
        this.onFailCallback = callback;
        return this;
    }
    onValidate(callback) {
        this.onValidateCallback = callback;
        return this;
    }
}


class $e119735f30012d0d$var$AdminLoginModal extends (0, $3cb67d0201f829e7$export$2e2bcd8739ae039) {
    _form = document.querySelector('.adminLoginModal');
    _formOverlay = document.querySelector('.login-overlay');
    _submitButton = document.querySelector('.login-submit-btn');
    _toggleLoginButton = document.querySelector('.toggle-login-btn');
    _spinnerDiv = document.querySelector('.spinner-div');
    _spinner = document.querySelector('.spinner');
    _usernameEl = document.getElementById('username');
    _validator;
    constructor(){
        super('.adminLoginModal', '.login-overlay', '.toggle-login-btn', 'login-submit-btn'); // Pass selectors to parent class
        // Initialize validation
        this._initValidation();
    }
    // Initialize validation rules
    _initValidation() {
        if (!this._form) return;
        this._validator = new (0, $d27bb703914f23c0$export$2e2bcd8739ae039)(this._form, {
            errorLabelCssClass: 'error-message',
            tooltip: {
                position: 'top'
            },
            lockForm: true
        });
        this._validator.addField('#username', [
            {
                rule: 'required',
                errorMessage: 'Username is required'
            },
            {
                rule: 'minLength',
                value: 3,
                errorMessage: 'Username must be at least 3 characters'
            }
        ]).addField('#password', [
            {
                rule: 'required',
                errorMessage: 'Password is required'
            },
            {
                rule: 'minLength',
                value: 6,
                errorMessage: 'Password must be at least 6 characters'
            }
        ]);
    }
    // Handle validation failure
    _handleFailure() {
        // Focus on the first invalid field
        const firstInvalidField = document.querySelector('.is-invalid');
        if (firstInvalidField) firstInvalidField.focus();
    }
    // Get form data
    getFormData() {
        return {
            username: document.getElementById('username').value,
            password: document.getElementById('password').value
        };
    }
    // Display spinner
    renderSpinner(message = '') {
        // Hide form elements while keeping them in the DOM
        this._form.querySelectorAll('h2, label, input, button').forEach((el)=>el.style.display = 'none');
        // Show the spinner
        this._spinnerDiv.style.display = 'flex';
        this._spinnerDiv.style.flexDirection = 'column';
        this._spinnerDiv.style.gap = '1rem';
        this._spinnerDiv.classList.remove('hidden');
        this._spinnerDiv.classList.add('visible');
        this._spinnerDiv.querySelector('p').textContent = message || 'Loading...';
    }
    // Hide spinner
    cancelSpinner() {
        // Restore visibility of form elements
        this._form.querySelectorAll('h2, label, input, button').forEach((el)=>el.style.display = 'block');
        // Hide the spinner
        this._spinnerDiv.style.display = 'none';
        this._spinnerDiv.classList.remove('visible');
        this._spinnerDiv.classList.add('hidden');
    }
}
var $e119735f30012d0d$export$2e2bcd8739ae039 = new $e119735f30012d0d$var$AdminLoginModal();







class $e88b5d50b08fa35d$var$NewAptView extends (0, $3cb67d0201f829e7$export$2e2bcd8739ae039) {
    _form = document.querySelector('.newAppointmentForm');
    _formOverlay = document.querySelector('.form-overlay');
    _errorMessages = document.querySelectorAll('.error-message');
    _toggleFormButton = document.querySelector('.cta-btn');
    _submitButton = document.querySelector('.form-submit-btn');
    _cancelButton = document.querySelector('.form-cancel-btn');
    _spinnerDiv = document.querySelector('.form-spinner-div');
    _spinner = document.querySelector('.spinner');
    _validator;
    _addressInput = document.getElementById('streetAddress');
    _suggestionsContainer = document.getElementById('suggestions');
    _zipCodeEL = document.getElementById('zipCode');
    _currentQuery = '';
    _fullNameEl = document.getElementById('fullName');
    _id;
    _emailEl = document.getElementById('email');
    _streetAddressEl = document.getElementById('streetAddress');
    _zipCodeEl = document.getElementById('zipCode');
    _secondLineAddressEl = document.getElementById('secondLineAddress');
    _aptDateEl = document.getElementById('aptDate');
    _aptTimeslotEl = document.getElementById('aptTimeslot');
    _editingSessionFinished = null;
    constructor(){
        super('.newAppointmentForm', '.form-overlay', '.cta-btn', 'form-submit-btn'); // Pass selectors to parent class
        // Initialize validation and event listeners
        this._initValidation();
        this._initAddressSuggestions();
    }
    _handleCancel() {
        this._form._clear(); // Clear the form state
        localStorage.removeItem('pendingAppointment'); // Remove pending appointment data
        this._form.reset(); // Reset the form
        this.cancelSpinner(); // Hide spinner if displayed
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).open({
            type: 'warning',
            message: 'Your appointment request was canceled'
        });
        this.handleToggleModal(); // Close modal window if needed
    }
    renderSpinner(message = '') {
        // Hide all form elements
        this._form.querySelectorAll('h2, label, input, select, button, textarea, .form-fields').forEach((el)=>{
            el.style.display = 'none';
        });
        // Show the spinner
        this._spinnerDiv.style.display = 'flex';
        this._spinnerDiv.classList.remove('hidden');
        this._spinnerDiv.classList.add('visible');
        this._spinnerDiv.querySelector('p').textContent = message || 'Processing...';
        const spinnerCancelButton = this._spinnerDiv.querySelector('.spinner-cancel-btn');
        spinnerCancelButton?.addEventListener('click', ()=>this._handleCancel());
    }
    cancelSpinner() {
        // Hide spinner
        if (this._spinnerDiv) {
            this._spinnerDiv.style.display = 'none';
            this._spinnerDiv.classList.add('hidden');
            this._spinnerDiv.classList.remove('visible');
        }
        // Restore form elements only if explicitly required (spinner cancel or process completed)
        this._form.querySelectorAll('h2, label, input, select, button, textarea, .form-fields').forEach((el)=>{
            el.style.display = 'block';
        });
    }
    // Initialize validation rules once
    _initValidation() {
        this._validator = new (0, $d27bb703914f23c0$export$2e2bcd8739ae039)(this._form, {
            errorLabelCssClass: 'error-message',
            tooltip: {
                position: 'top'
            },
            lockForm: true
        });
        this._validator.addField('#fullName', [
            {
                rule: 'required',
                errorMessage: 'Full Name is required'
            },
            {
                rule: 'minLength',
                value: 3,
                errorMessage: 'Full Name must be at least 3 characters'
            },
            {
                validator: (value)=>value.trim().split(' ').length >= 2,
                errorMessage: 'Full Name must contain at least two words'
            }
        ]).addField('#email', [
            {
                rule: 'required',
                errorMessage: 'Email is required'
            },
            {
                rule: 'email',
                errorMessage: 'Email format is incorrect'
            }
        ]).addField('#streetAddress', [
            {
                rule: 'required',
                errorMessage: 'Street Address is required'
            }
        ]).addField('#zipCode', [
            {
                rule: 'required',
                errorMessage: 'Zip Code is required'
            },
            {
                rule: 'number',
                errorMessage: 'Must be a 5 digit LA county Zip Code'
            },
            {
                rule: 'minLength',
                value: 5,
                errorMessage: 'Zip Code must be exactly 5 digits'
            },
            {
                rule: 'maxLength',
                value: 5,
                errorMessage: 'Zip Code must be exactly 5 digits'
            }
        ]).addField('#aptDate', [
            {
                rule: 'required',
                errorMessage: 'Appointment Date is required'
            },
            {
                validator: (value)=>new Date(value) >= new Date(),
                errorMessage: 'Please choose a future date'
            }
        ]).addField('#aptTimeslot', [
            {
                rule: 'required',
                errorMessage: '2h timeslot must be selected'
            }
        ]);
        return this._validator;
    }
    // Initialize address suggestion functionality
    _initAddressSuggestions() {
        const displaySuggestions = (matches)=>{
            this._suggestionsContainer.innerHTML = '';
            if (!matches.length) {
                const noMatch = document.createElement('div');
                noMatch.className = 'suggestion-item';
                noMatch.textContent = 'No matches found';
                this._suggestionsContainer.appendChild(noMatch);
                return;
            }
            matches.forEach((match)=>{
                const suggestionItem = document.createElement('div');
                suggestionItem.className = 'suggestion-item';
                suggestionItem.textContent = `${match.streetNumber || ''} ${match.streetDirection || ''} ${match.streetName} ${match.streetType || ''}, ${match.zipCode || ''}`.trim();
                suggestionItem.dataset.address = JSON.stringify(match);
                suggestionItem.addEventListener('click', ()=>{
                    const addressText = suggestionItem.textContent.trim();
                    const addressWithoutZip = addressText.replace(/\s*\d{5}(\s*\-\s*\d{4})?(\s*,\s*)?$/, '').trim();
                    this._addressInput.value = addressWithoutZip.replace(',', '');
                    this._suggestionsContainer.innerHTML = '';
                    this._suggestionsContainer.style.display = 'none';
                });
                this._suggestionsContainer.appendChild(suggestionItem);
            });
        };
        const handleAddressInput = async ()=>{
            const query = this._addressInput.value.trim();
            const zipCode = this._zipCodeEL.value.trim();
            if (query.length < 2) {
                this._suggestionsContainer.innerHTML = '';
                return;
            }
            if (query === this._currentQuery) return;
            this._currentQuery = query;
            this._suggestionsContainer.innerHTML = '<p>Loading suggestions...</p>';
            try {
                const matches = zipCode.length >= 5 ? await (0, $85015d9f7ab58335$export$7c06382ce0ff786b)(zipCode, query) : await (0, $85015d9f7ab58335$export$7c06382ce0ff786b)(query);
                displaySuggestions(matches);
            } catch (err) {
                console.error('Error fetching address suggestions:', err);
            }
        };
        this._addressInput.addEventListener('input', (0, $85015d9f7ab58335$export$61fc7d43ac8f84b0)(handleAddressInput, 300));
        this._zipCodeEL.addEventListener('input', (0, $85015d9f7ab58335$export$61fc7d43ac8f84b0)(handleAddressInput, 300));
        document.addEventListener('click', (event)=>{
            if (!this._suggestionsContainer.contains(event.target) && event.target !== this._addressInput) {
                this._suggestionsContainer.innerHTML = '';
                this._suggestionsContainer.style.display = 'none';
            }
        });
        this._addressInput.addEventListener('focus', ()=>{
            if (this._suggestionsContainer.innerHTML.trim()) this._suggestionsContainer.style.display = 'block';
        });
        this._suggestionsContainer.addEventListener('mousedown', (event)=>{
            event.preventDefault();
        });
        this._addressInput.addEventListener('blur', ()=>{
            setTimeout(()=>{
                this._suggestionsContainer.style.display = 'none';
            }, 200);
        });
    }
    _handleFailure() {
        const firstInvalidField = document.querySelector('.is-invalid');
        if (firstInvalidField) firstInvalidField.focus();
    }
    populateFormWithExistingData(appointment) {
        this._id = appointment.id; // save id in this._id
        this._form.classList.add('edit-session');
        this._submitButton.textContent = 'Save changes';
        this._submitButton.classList.add('edit-session');
        this._submitButton.classList.remove('form-submit-btn');
        this._submitButton.removeAttribute('type');
        const titleEl = this._form.querySelector('h2');
        titleEl.textContent = 'Editing Appointment... ';
        // Update the form input fields with the existing appointment data
        this._fullNameEl.value = appointment.fullName || '';
        this._emailEl.value = appointment.email || '';
        this._streetAddressEl.value = appointment.streetAddress || '';
        this._zipCodeEl.value = appointment.zipCode || '';
        this._secondLineAddressEl.value = appointment.secondLineAddress || '';
        this._aptDateEl.value = appointment.aptDate || '';
        this._aptTimeslotEl.value = appointment.aptTimeslot || '';
    }
    async _saveEditedAppointment() {
        const updatedAppointment = this.getFormData(true);
        // Update the appointment in the appointments array (find by ID or other identifier)
        const index = $0f1d4402dffacf5b$export$a0e153c73743701a.appointments.findIndex((appt)=>+appt.id === +updatedAppointment.id);
        if (index !== -1) {
            $0f1d4402dffacf5b$export$a0e153c73743701a.appointments[index] = updatedAppointment; // Update appointment
            (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).success('Appointment successfully updated!');
        } else (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).error('Appointment not found for updating!');
        // Resolve the editing session promise
        if (this._editingSessionFinished) this._editingSessionFinished(true); // Notify that editing is finished
        this._resetEditSession();
    }
    _resetEditSession() {
        // Reset after editing
        this.handleToggleModal();
        this._form.classList.remove('edit-session'); // Reset form to "create" mode
        this._submitButton.classList.remove('edit-session');
        this._submitButton.classList.add('form-submit-btn');
        this._submitButton.type = 'submit';
        this._submitButton.textContent = 'Create Appointment'; // Restore button text
    }
    async isEditingFinished() {
        return new Promise((resolve)=>{
            this._editingSessionFinished = resolve; // Store the resolve function to call it later when editing is finished
        });
    }
    async getUpdatedFormData() {
        // Check if the editing is finished
        const isFinished = await this.isEditingFinished();
        if (isFinished) // Retrieve and return the form data
        return this.getFormData(true); // or any other form data fetching logic
        return null; // Return null if editing is not finished
    }
    getFormData(isEditingSession) {
        if (isEditingSession) return {
            fullName: this._fullNameEl.value,
            id: this._id,
            secondLineAddress: this._secondLineAddressEl.value,
            aptDate: this._aptDateEl.value,
            aptTimeslot: this._aptTimeslotEl.value,
            zipCode: this._zipCodeEl.value,
            streetAddress: this._streetAddressEl.value,
            email: this._emailEl.value
        };
        else return {
            fullName: this._fullNameEl.value,
            id: Math.random().toString(36).substr(2, 9),
            email: this._emailEl.value,
            streetAddress: this._streetAddressEl.value,
            secondLineAddress: this._secondLineAddressEl.value,
            aptDate: this._aptDateEl.value,
            aptTimeslot: this._aptTimeslotEl.value,
            zipCode: this._zipCodeEl.value
        };
    }
}
var $e88b5d50b08fa35d$export$2e2bcd8739ae039 = new $e88b5d50b08fa35d$var$NewAptView();


// AppointmentsView.js


class $d570d3d007487354$var$AppointmentsView {
    _tableBody;
    _appointmentsPerPage = 5;
    _currentPage = 1;
    _currentFilter = 'all-appointments';
    _paginationContainer;
    constructor(){
        this._tableBody = document.querySelector('#appointments-tbody');
        this._paginationContainer = document.querySelector('#pagination-controls');
        this.displayAppointments();
        this._addNavigationEventListeners();
        this._updateFilterText();
    }
    _addNavigationEventListeners() {
        const filters = [
            {
                id: 'all-appointments',
                filter: 'all'
            },
            {
                id: 'todays-appointments',
                filter: 'today'
            },
            {
                id: 'next-7-days',
                filter: 'next7days'
            },
            {
                id: 'next-30-days',
                filter: 'next30days'
            }
        ];
        filters.forEach(({ id: id, filter: filter })=>{
            document.getElementById(id).addEventListener('click', ()=>{
                // If the clicked filter is already active, do nothing
                if (this._currentFilter === filter) return;
                // Remove 'active' class from all elements
                filters.forEach(({ id: id })=>{
                    document.getElementById(id).classList.remove('active');
                });
                // Add 'active' class to the clicked element
                document.getElementById(id).classList.add('active');
                document.getElementById(id).blur();
                // Set the current filter and page, then display appointments
                this._currentFilter = filter;
                this._currentPage = 1;
                this.displayAppointments(filter);
                this._updateFilterText();
            });
        });
    }
    _updateFilterText() {
        const filterTextElement = document.querySelector('.admin-section-p');
        if (filterTextElement) filterTextElement.textContent = `Showing ${this._currentFilter}`;
    }
    handleModifyButtonClick(appointmentId) {
        const appointment = this._getAppointmentsFromLocalStorage().find((appt)=>appt.id === appointmentId);
        if (appointment) this.renderEditForm(appointment); // Pass the appointment with the existing ID
    }
    renderEditForm(appointment) {
        // Open the modal
        (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).toggleVisibility(document.querySelector('.newAppointmentForm'), document.querySelector('.form-overlay'));
        (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).populateFormWithExistingData(appointment); // Populate the form with existing data
    }
    // Handle modal toggle
    handleToggleModal() {
        const formContainer = document.querySelector('.edit-form-container');
        if (formContainer) formContainer.remove();
    }
    generateMockAppointments() {
        const appointments = [];
        const names = [
            'John Doe',
            'Jane Smith',
            'Alice Johnson',
            'Bob Brown'
        ];
        const timeslots = [
            '7AM-9AM',
            '9AM-11AM',
            '11AM-1PM',
            '1PM-3PM',
            '3PM-5PM',
            '5PM-7PM'
        ];
        function getRandomDate() {
            const today = new Date();
            const randomizer = Math.random();
            let randomDate;
            if (randomizer < 0.3) // 30% chance for appointments today
            randomDate = new Date(today);
            else if (randomizer < 0.7) {
                // 40% chance for appointments in the next 7 days
                const daysAhead = Math.floor(Math.random() * 7) + 1;
                randomDate = new Date(today);
                randomDate.setDate(today.getDate() + daysAhead);
            } else {
                // 30% chance for appointments in the next 30 days
                const daysAhead = Math.floor(Math.random() * 30) + 8;
                randomDate = new Date(today);
                randomDate.setDate(today.getDate() + daysAhead);
            }
            const year = randomDate.getFullYear();
            const month = ('0' + (randomDate.getMonth() + 1)).slice(-2);
            const day = ('0' + randomDate.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        }
        function getRandomTimeslot() {
            const randomIndex = Math.floor(Math.random() * timeslots.length);
            return timeslots[randomIndex];
        }
        //  prettier-ignore
        const validZipCodes = [
            '90001',
            '90002',
            '90003',
            '90004',
            '90005',
            '90006',
            '90007',
            '90008',
            '90009',
            '90010',
            '90011',
            '90012',
            '90013',
            '90014',
            '90015',
            '90016',
            '90017',
            '90018',
            '90019',
            '90020',
            '90021',
            '90022',
            '90023',
            '90024',
            '90025',
            '90026',
            '90027',
            '90028',
            '90029',
            '90030',
            '90031',
            '90032',
            '90033',
            '90034',
            '90035',
            '90036',
            '90037',
            '90038',
            '90039',
            '90040'
        ];
        for(let i = 0; i < 66; i++){
            const appointment = {
                fullName: names[Math.floor(Math.random() * names.length)],
                id: Math.random().toString(),
                email: `user${i}@example.com`,
                streetAddress: `${Math.floor(Math.random() * 1000)} ${[
                    'S',
                    'W',
                    'E',
                    'N'
                ][Math.floor(Math.random() * 4)]} Bentley`,
                zipCode: validZipCodes[Math.floor(Math.random() * validZipCodes.length)],
                secondLineAddress: Math.floor(Math.random() * 200) + 1,
                aptDate: getRandomDate(),
                aptTimeslot: getRandomTimeslot(),
                status: 'confirmed'
            };
            appointments.push(appointment);
        }
        (0, $bd02c871d9c5ba8e$export$890112004ddfc4a1)(appointments);
        this.displayAppointments();
        return appointments;
    }
    _filterAppointmentsForToday(appointments) {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
        return appointments.filter((appt)=>appt.aptDate === today);
    }
    _filterAppointmentsNext7Days(appointments) {
        const today = new Date();
        const next7Days = new Date(today);
        next7Days.setDate(today.getDate() + 7);
        return appointments.filter((appt)=>{
            const appointmentDate = new Date(appt.aptDate);
            return appointmentDate >= today && appointmentDate <= next7Days;
        });
    }
    _filterAppointmentsNext30Days(appointments) {
        const today = new Date();
        const next30Days = new Date(today);
        next30Days.setDate(today.getDate() + 30);
        return appointments.filter((appt)=>{
            const appointmentDate = new Date(appt.aptDate);
            return appointmentDate >= today && appointmentDate <= next30Days;
        });
    }
    _renderPagination(totalNumAppointments) {
        const totalPages = Math.ceil(totalNumAppointments / this._appointmentsPerPage);
        this._paginationContainer.innerHTML = ''; // Clear existing pagination
        // Create the main container for pagination controls
        const paginationControls = document.createElement('div');
        paginationControls.classList.add('pagination-controls');
        paginationControls.style.display = 'flex';
        paginationControls.style.flexDirection = 'row';
        // Create Prev button
        const prevButton = document.createElement('button');
        prevButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#5d5a88" viewBox="0 0 256 256"><path d="M224,88v80a16,16,0,0,1-16,16H128v40a8,8,0,0,1-13.66,5.66l-96-96a8,8,0,0,1,0-11.32l96-96A8,8,0,0,1,128,32V72h80A16,16,0,0,1,224,88Z"></path></svg>';
        prevButton.classList.add('pagination-btn', 'pagination-prev');
        prevButton.disabled = this._currentPage === 1;
        prevButton.addEventListener('click', ()=>{
            if (this._currentPage > 1) {
                this._currentPage--;
                this.displayAppointments(this._currentFilter); // Pass current filter
            }
        });
        paginationControls.appendChild(prevButton);
        // Create Page buttons
        for(let i = 1; i <= totalPages; i++){
            const button = document.createElement('button');
            button.textContent = i;
            button.classList.add('pagination-button');
            if (i === this._currentPage) button.classList.add('active');
            button.addEventListener('click', ()=>{
                this._currentPage = i;
                this.displayAppointments(this._currentFilter); // Pass current filter
            });
            paginationControls.appendChild(button);
        }
        // Create Next button
        const nextButton = document.createElement('button');
        nextButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#5d5a88" viewBox="0 0 256 256"><path d="M237.66,133.66l-96,96A8,8,0,0,1,128,224V184H48a16,16,0,0,1-16-16V88A16,16,0,0,1,48,72h80V32a8,8,0,0,1,13.66-5.66l96,96A8,8,0,0,1,237.66,133.66Z"></path></svg>';
        nextButton.classList.add('pagination-btn', 'pagination-next');
        nextButton.disabled = this._currentPage === totalPages;
        nextButton.addEventListener('click', ()=>{
            if (this._currentPage < totalPages) {
                this._currentPage++;
                this.displayAppointments(this._currentFilter); // Pass current filter
            }
        });
        paginationControls.appendChild(nextButton);
        // Append the pagination buttons container to the main pagination container
        this._paginationContainer.appendChild(paginationControls);
        // Create the page info container
        const paginationInfoContainer = document.createElement('div');
        paginationInfoContainer.classList.add('pagination-info-container');
        // Calculate and display results info (e.g., "Showing 5/55 results")
        const startResult = (this._currentPage - 1) * this._appointmentsPerPage + 1;
        const endResult = Math.min(this._currentPage * this._appointmentsPerPage, totalNumAppointments);
        const paginationInfo = document.createElement('span');
        paginationInfo.classList.add('pagination-info');
        paginationInfo.style.backgroundColor = '#ff9000';
        paginationInfo.style.borderRadius = '20px';
        paginationInfo.style.fontWeight = '800';
        paginationInfo.style.padding = '0.5rem 3rem';
        paginationInfo.textContent = `Showing ${startResult}-${endResult} / ${totalNumAppointments} total results`;
        paginationInfoContainer.appendChild(paginationInfo);
        // Append the pagination info container to the main pagination container
        this._paginationContainer.prepend(paginationInfoContainer);
    }
    displayAppointments(filter = this._currentFilter) {
        let appointments = this._getAppointmentsFromLocalStorage();
        if (!appointments || Array.isArray(appointments) && appointments.length === 0) appointments = this.generateMockAppointments();
        // Apply the selected filter
        if (filter === 'today') appointments = this._filterAppointmentsForToday(appointments);
        else if (filter === 'next7days') appointments = this._filterAppointmentsNext7Days(appointments);
        else if (filter === 'next30days') appointments = this._filterAppointmentsNext30Days(appointments);
        // Calculate paginated results
        const start = (this._currentPage - 1) * this._appointmentsPerPage;
        const end = start + this._appointmentsPerPage;
        const paginatedAppointments = appointments.slice(start, end);
        // Check if there are appointments to display
        if (!appointments || appointments.length === 0) {
            this._tableBody.innerHTML = '<tr><td colspan="6">No appointments available</td></tr>';
            this._paginationContainer.style.display = 'none';
            return;
        }
        if (!paginatedAppointments || paginatedAppointments.length === 0) this._tableBody.innerHTML = '<tr><td colspan="6">No appointments available for this page</td></tr>';
        else {
            // Generate table rows
            const rows = paginatedAppointments.map((appt)=>`
        <tr>
          <td>${appt.fullName}</td>
          <td>${appt.streetAddress}</td>
          <td>${(0, $bd02c871d9c5ba8e$export$3ae94a2503e890a1)(appt.aptDate, {
                    day: 'numeric',
                    month: 'short',
                    weekday: 'short'
                })}</td>
          <td>${appt.aptTimeslot}</td>
          <td>${appt.status || 'confirmed'}</td>
          <td>
<button class="action-button modify-button" data-tooltip="Modify" data-id="${appt.id}">
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#5d5a88" viewBox="0 0 256 256">
    <path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31l83.67-83.66,3.48,13.9-36.8,36.79a8,8,0,0,0,11.31,11.32l40-40a8,8,0,0,0,2.11-7.6l-6.9-27.61L227.32,96A16,16,0,0,0,227.32,73.37ZM192,108.69,147.32,64l24-24L216,84.69Z"></path>
  </svg>
</button>
<button class="action-button cancel-button" data-tooltip="Cancel" data-id="${appt.id}">
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#5d5a88" viewBox="0 0 256 256"><path d="M224,56a8,8,0,0,1-8,8h-8V208a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,56ZM88,32h80a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z"></path></svg>
  
</button>
          </td>
        </tr>
      `);
            this._tableBody.innerHTML = rows.join('');
        }
        // Render pagination if more than one page of results
        if (appointments.length > this._appointmentsPerPage) {
            this._paginationContainer.style.display = 'flex';
            this._renderPagination(appointments.length);
        } else this._paginationContainer.style.display = 'none';
    }
    _getAppointmentsFromLocalStorage() {
        const appointmentsJSON = localStorage.getItem('appointments');
        return appointmentsJSON ? JSON.parse(appointmentsJSON) : [];
    }
    addHandlerActionButton(handlerFunction) {
        this._tableBody.addEventListener('click', function(e) {
            const button = e.target.closest('.action-button');
            if (!button) return;
            const appointmentId = button.dataset.id;
            handlerFunction(button, appointmentId);
        });
    }
}
var $d570d3d007487354$export$2e2bcd8739ae039 = new $d570d3d007487354$var$AppointmentsView();


class $346da4f75362e00b$var$CustomerSlider {
    constructor(){
        this.slides = document.querySelectorAll('.slide');
        this.sliderBtnLeft = document.querySelector('.slider-btn-left');
        this.sliderBtnRight = document.querySelector('.slider-btn-right');
        this.dots = document.querySelector('.dots');
        this.currSlide = 0;
        this.maxSlide = this.slides.length - 1;
        this.minSlide = 0;
        this.init();
    }
    init() {
        this._setSlideTransforms();
        this._createDots();
        this._activateDot(this.currSlide);
        this._addEventListeners();
    }
    // Set initial slide transforms
    _setSlideTransforms() {
        this.slides.forEach((s, i)=>{
            s.style.transform = `translateX(${i * 100}%)`;
        });
    }
    // Go to a specific slide
    _goToSlide(goTo) {
        this.currSlide = goTo;
        this.slides.forEach((s, i)=>s.style.transform = `translateX(${(i - goTo) * 100}%)`);
    }
    // Show next slide
    _nextSlide() {
        if (this.currSlide === this.maxSlide) this._goToSlide(0);
        else {
            this.currSlide++;
            this._goToSlide(this.currSlide);
        }
        this._activateDot(this.currSlide);
    }
    // Show previous slide
    _prevSlide() {
        if (this.currSlide === 0) this._goToSlide(this.maxSlide);
        else {
            this.currSlide--;
            this._goToSlide(this.currSlide);
        }
        this._activateDot(this.currSlide);
    }
    // Create dots for slider navigation
    _createDots() {
        this.slides.forEach((_, i)=>{
            const html = `<button class="dot" data-slide="${i}"></button>`;
            this.dots.insertAdjacentHTML('beforeend', html);
        });
    }
    // Activate a specific dot
    _activateDot(slide) {
        document.querySelectorAll('.dot').forEach((dot)=>{
            dot.classList.remove('dot-active');
        });
        document.querySelector(`.dot[data-slide="${slide}"]`).classList.add('dot-active');
    }
    // Add event listeners
    _addEventListeners() {
        // Event listener for dot click
        this.dots.addEventListener('click', (e)=>{
            e.preventDefault();
            const clickedDot = e.target.closest('.dot');
            if (!clickedDot) return;
            const dotNumber = clickedDot.dataset.slide;
            this._goToSlide(dotNumber);
            this._activateDot(dotNumber);
        });
        // Event listeners for slider buttons
        this.sliderBtnRight.addEventListener('click', ()=>this._nextSlide());
        this.sliderBtnLeft.addEventListener('click', ()=>this._prevSlide());
        // Event listeners for keyboard arrows
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                e.preventDefault();
                if (e.key === 'ArrowRight') this._nextSlide();
                if (e.key === 'ArrowLeft') this._prevSlide();
                this._activateDot(this.currSlide);
            }
        });
    }
}
// Instantiate and initialize the slider
const $346da4f75362e00b$var$slider = new $346da4f75362e00b$var$CustomerSlider();



// ! weird stuff going on on submit - with the spinner especially
async function $f50bd1f2915ed0f2$var$controlAppointmentFormSubmit(formData) {
    let err1; // Declare a variable to store error if it occurs
    try {
        // Save form data to localStorage for persistence
        localStorage.setItem('pendingAppointment', JSON.stringify(formData));
        // Show loading spinner or feedback to the user
        (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).renderSpinner('Processing your appointment... Feel free to check out the rest of the page in the meantime!');
        // Dynamically add "Processing appointment" to the header nav list
        const processingNavItem = document.createElement('li');
        processingNavItem.classList.add('header-nav-item');
        processingNavItem.id = 'processing-appointment';
        processingNavItem.innerHTML = '<span>Appointment is being processed...</span>';
        document.querySelector('.header-nav-list').appendChild(processingNavItem);
        // 1) Fetch and validate the address
        const { streetAddress: streetAddress, zipCode: zipCode } = formData;
        const isValidAddress = await (0, $85015d9f7ab58335$export$5bafc354b7e37022)(zipCode, streetAddress);
        if (!isValidAddress) throw new Error('Your address could not be found in our database. Please try again and select a valid address from the suggestions pop-up!');
        // Address is valid, proceed to add the appointment
        $0f1d4402dffacf5b$export$a0e153c73743701a.addAppointment(formData);
        // Remove pending appointment from localStorage
        $0f1d4402dffacf5b$export$a0e153c73743701a.clearPendingAppointment();
        // Render success message after the appointment is confirmed
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).open({
            type: 'confirmation',
            message: `Successfully booked for ${formData.aptTimeslot} on ${(0, $bd02c871d9c5ba8e$export$3ae94a2503e890a1)(formData.aptDate)}! If you need to modify/cancel, please call us at +1-800-88-000`
        });
    } catch (error) {
        err1 = error; // Assign error to the err variable
        console.error(err1.message || err1);
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).error(`Could not create your appointment. ${err1.message}.`);
    } finally{
        // Cleanup: Remove pendingAppointment from localStorage, cancel spinner, and reset form
        $0f1d4402dffacf5b$export$a0e153c73743701a.clearPendingAppointment();
        (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).cancelSpinner();
        (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039)._form.reset();
        // Remove the "Processing appointment" message
        const processingNavItem = document.getElementById('processing-appointment');
        if (processingNavItem) processingNavItem.remove();
        // Close modal window if no error occurred
        if (!err1) (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).handleToggleModal(); // Close modal window
    }
}
async function $f50bd1f2915ed0f2$var$controlAdminLogin(formData) {
    try {
        // Show loading spinner or feedback to the user
        (0, $e119735f30012d0d$export$2e2bcd8739ae039).renderSpinner('Checking your credentials...');
        // Credentials check
        const credentialsGood = formData.username === (0, $ba30e20475feac5a$export$413899dff10bd19d).username && formData.password === (0, $ba30e20475feac5a$export$413899dff10bd19d).password;
        if (credentialsGood) setTimeout(()=>{
            (0, $bd02c871d9c5ba8e$export$5437abf948861fe0)(document.querySelector('.toggle-login-btn a')); // header switch
            (0, $bd02c871d9c5ba8e$export$838972faedb21271)(document.querySelectorAll('section')); // content / UI switch
            (0, $e119735f30012d0d$export$2e2bcd8739ae039).handleToggleModal(); // Close modal window
            (0, $e119735f30012d0d$export$2e2bcd8739ae039).cancelSpinner();
            (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).success('Login successful!');
        }, 1000);
        else {
            (0, $e119735f30012d0d$export$2e2bcd8739ae039).cancelSpinner();
            (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).error('Wrong username or password... please try again');
        }
        // Success - make it current account
        $0f1d4402dffacf5b$export$a0e153c73743701a.setAdminAccount(formData);
    } catch (error) {
        console.error(error.message || err);
    } finally{
        (0, $e119735f30012d0d$export$2e2bcd8739ae039)._form.reset(); // reset form
    }
}
function $f50bd1f2915ed0f2$var$controlAdminLogout() {
    const isLogoutConfirmed = window.confirm('Are you sure you want to log out of your admin account?');
    if (!isLogoutConfirmed) return (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).error('Log out cancelled by the admin');
    // Reset the login state (Hide admin login UI and show the login button)
    (0, $bd02c871d9c5ba8e$export$4190cb8f14494955)(document.querySelector('.toggle-login-btn a')); // Reset header to "Admin Login"
    (0, $bd02c871d9c5ba8e$export$f633bf8f6c244212)(document.querySelectorAll('section')); // Reset content/UI
    // Optionally, clear out current admin account info
    $0f1d4402dffacf5b$export$a0e153c73743701a.clearAdminAccount();
    // Reset form
    (0, $e119735f30012d0d$export$2e2bcd8739ae039)._form.reset(); // Reset the login form
    (0, $e119735f30012d0d$export$2e2bcd8739ae039).cancelSpinner(); // Hide the spinner if it's visible
    // Ensure the "Processing" state is removed
    const processingNavItem = document.getElementById('processing-appointment');
    if (processingNavItem) processingNavItem.remove();
    (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).success('Successfully logged out');
}
// modify appointment
// modify appointment
async function $f50bd1f2915ed0f2$var$controlModifyAppointment(appointmentId) {
    try {
        // Retrieve the existing appointment data from the model
        const appointment = $0f1d4402dffacf5b$export$a0e153c73743701a.appointments.find((appt)=>appt.id === appointmentId);
        if (!appointment) throw new Error('Appointment not found.');
        // Open the appointment modification form with the current data
        (0, $d570d3d007487354$export$2e2bcd8739ae039).renderEditForm(appointment);
        // Ensure the form has finished editing before we continue
        const updatedAppointment = await (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).getUpdatedFormData();
        if (!updatedAppointment) throw new Error('Failed to retrieve updated appointment data.');
        // Modify the appointment in the model
        $0f1d4402dffacf5b$export$a0e153c73743701a.modifyAppointment(appointmentId, updatedAppointment);
        // Update appointments view
        (0, $d570d3d007487354$export$2e2bcd8739ae039).displayAppointments();
        // Display success message
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).success('Appointment successfully updated!');
        // Optionally, close the form/modal
        (0, $d570d3d007487354$export$2e2bcd8739ae039).handleToggleModal();
    } catch (err1) {
        console.error(err1);
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).error(`Failed to modify the appointment. ${err1.message}`);
    } finally{
        // Ensure the form/modal is closed
        (0, $d570d3d007487354$export$2e2bcd8739ae039).handleToggleModal();
    }
}
// cancel appointment
async function $f50bd1f2915ed0f2$var$controlCancelAppointment(appointmentId) {
    try {
        // Retrieve the existing appointment data from the model
        const appointment = $0f1d4402dffacf5b$export$a0e153c73743701a.appointments.find((appt)=>appt.id === appointmentId);
        if (!appointment) throw new Error('Appointment not found.');
        // Confirm cancellation
        const confirmCancel = window.confirm('Are you sure you want to cancel this appointment?');
        if (!confirmCancel) return;
        // Cancel the appointment in the model
        $0f1d4402dffacf5b$export$a0e153c73743701a.cancelAppointment(appointmentId);
        // Display a success message
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).success('Appointment successfully cancelled!');
        // Refresh the appointment list
        (0, $d570d3d007487354$export$2e2bcd8739ae039).displayAppointments();
    } catch (err1) {
        console.error(err1);
        (0, $bd02c871d9c5ba8e$export$6c49cf36d8dc363f).error(`Failed to cancel the appointment. ${err1.message}`);
    }
}
async function $f50bd1f2915ed0f2$var$init() {
    $0f1d4402dffacf5b$export$a0e153c73743701a.initializeState();
    // * check for pending requests and finish them
    if ($0f1d4402dffacf5b$export$a0e153c73743701a.pendingAppointmentObject) $f50bd1f2915ed0f2$var$controlAppointmentFormSubmit($0f1d4402dffacf5b$export$a0e153c73743701a.pendingAppointmentObject);
    (0, $e88b5d50b08fa35d$export$2e2bcd8739ae039).addHandlerSubmitForm($f50bd1f2915ed0f2$var$controlAppointmentFormSubmit);
    (0, $e119735f30012d0d$export$2e2bcd8739ae039).addHandlerSubmitForm($f50bd1f2915ed0f2$var$controlAdminLogin);
    //* Add event listener for action buttons (modify/cancel)
    (0, $d570d3d007487354$export$2e2bcd8739ae039).addHandlerActionButton((button, appointmentId)=>{
        if (button.classList.contains('modify-button')) $f50bd1f2915ed0f2$var$controlModifyAppointment(appointmentId);
        else if (button.classList.contains('cancel-button')) $f50bd1f2915ed0f2$var$controlCancelAppointment(appointmentId);
    });
}
$f50bd1f2915ed0f2$var$init();
// ! Attach event listener to the home button
document.querySelector('.home-btn').addEventListener('click', ()=>{
    if ($0f1d4402dffacf5b$export$a0e153c73743701a.currentAdminAccount) $f50bd1f2915ed0f2$var$controlAdminLogout();
});


//# sourceMappingURL=index.887a21a1.js.map
